(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor', []);

})();

(function () {
  'use strict';

  angular
    .module('semy.vendor')
    .controller('VendorDetailController', VendorDetailController);

  VendorDetailController.$inject = ['$scope', '$log', '$window', '$stateParams', '$state', '$mdToast', 'Vendors', 'Geo'];

  function VendorDetailController($scope, $log, $window, $stateParams, $state, $mdToast, Vendors, Geo) {

    var vm = this;

    /// initialize
    vm.loading = false;
    vm.hideConnect = true;
    vm.vendor = {imageUrls: [], active: false};
    vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
      'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
      'WY').split(' ').map(function (state) {
      return {abbrev: state};
    });
    vm.save = save;
    vm.connectToStripe = connectToStripe;
    vm.geocode = geocode;

    activate();

    vm.onProfileImageUpload = function (imageUrl) {
      vm.vendor.imageUrl = imageUrl;
      $scope.$digest();
    };

    vm.onImageUpload = function (imageUrl) {
      vm.vendor.imageUrls.push(imageUrl);
      $scope.$digest();
    };

    vm.removeImageUrl = function (imageUrlIndex) {
      vm.vendor.imageUrls.splice(imageUrlIndex, 1);
    };

    vm.goToStripeDashboard = function () {
      var vendor = vm.vendor;
      if (angular.isUndefined(vendor) || angular.isUndefined(vendor.key)) {
        return;
      }

      var params = {objectKey: vendor.key};
      Vendors.dashboardLink(params, function (response) {
        $log.info(response);
        $window.open(response.link, '_blank');
      }, function (error) {
        $log.error(error);
      });
    };

    function connectToStripe(vendor) {

      if (angular.isUndefined(vendor) || angular.isUndefined(vendor.key)) {
        return;
      }

      vm.loading = true;

      var params = {objectKey: vm.vendor.key};
      Vendors.connectToStripe(params, vm.vendor, success, error);

      function success(response) {
        vm.hideConnect = true;
        vm.vendor = response;
        setDefaults(vm.vendor);
        vm.loading = false;
      }

      function error(error) {
        vm.loading = false;
        showError(error);
        $log.error(angular.toJson(error));
      }

    }

    function buildAddress(location) {

      var values = [];

      if (angular.isString(location.street)) {
        values.push(location.street);
      }
      if (angular.isString(location.city)) {
        values.push(location.city);
      }
      if (angular.isString(location.state)) {
        values.push(location.state);
      }
      if (angular.isString(location.postalCode)) {
        values.push(location.postalCode);
      }

      return values.join(' ');

    }

    function geocode() {

      var address = buildAddress(vm.vendor.location);

      Geo.code({address: address}, success, error);

      function success(response) {
        if (!angular.isArray(response.results) || response.results.length === 0) {
          return;
        }
        var result = response.results[0];
        var location = result.geometry.location;
        vm.vendor.location.latitude = location.lat;
        vm.vendor.location.longitude = location.lng;
      }

      function error(error) {
        $log.error(angular.toJson(error));
      }

    }

    function activate() {

      var key = $stateParams.objectKey;

      if (angular.isUndefined(key) || key === 'new') {
        return;
      }

      vm.loading = true;
      Vendors.get({objectKey: key}, success, error);

      function success(response) {
        vm.loading = false;
        vm.vendor = response || {};
        vm.vendor.location = vm.vendor.location || {};
        vm.vendor.active = vm.vendor.active || false;
        if (!angular.isString(vm.vendor.stripeId)) {
          vm.vendor.active = false;
        }
        vm.vendor.imageUrls = vm.vendor.imageUrls || [];
        if (angular.isUndefined(vm.vendor.stripeId)) {
          vm.hideConnect = false;
        }
      }

      function error(response) {
        vm.loading = false;
        $log.error(angular.toJson(response));
      }

    }

    function save(form) {
      form.$submitted = true;

      if (!form.$valid) {
        return;
      }

      vm.loading = true;

      if (angular.isDefined(vm.vendor.key)) {
        var params = {objectKey: vm.vendor.key};
        Vendors.update(params, vm.vendor, success, error);
      } else {
        Vendors.insert(vm.vendor, success, error);
      }

      function success(response) {
        vm.vendor = response;
        setDefaults(vm.vendor);
        if (angular.isUndefined(vm.vendor.stripeId)) {
          vm.hideConnect = false;
        }
        $state.go('admin.main.vendorDetail', {objectKey: vm.vendor.key}, {notify: false});
        vm.loading = false;
        showSuccess();
      }

      function error(error) {
        vm.loading = false;
        showError(error);
        $log.error(angular.toJson(error));
      }

    }

    function setDefaults(vendor) {
      vendor.imageUrls = vendor.imageUrls || [];
    }

    function setPrimaryImage(imageUrl) {
      vm.vendor.imageUrl = imageUrl;
    }

    function showSuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Saved!')
      );
    }

    function showError(error) {
      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(error.message || 'Something went wrong.')
      );
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('semy.vendor')
    .controller('VendorMenuController', VendorMenuController);

  VendorMenuController.$inject = ['$log', '$document', '$stateParams', '$mdDialog', '$mdToast', 'Vendors', 'VendorItems', 'VendorCategories', 'ItemTemplates'];

  function VendorMenuController($log, $document, $stateParams, $mdDialog, $mdToast, Vendors, VendorItems, VendorCategories, ItemTemplates) {

    var vm = this;

    vm.vendor = {};
    vm.categories = {};

    vm.addCategory = addCategory;
    vm.updateCategory = updateCategory;
    vm.deleteCategory = deleteCategory;
    vm.archiveCategory = archiveCategory;
    vm.resortItems = resortItems;

    vm.editItem = editItem;
    vm.toggleItemActive = toggleItemActive;
    vm.archiveItem = archiveItem;
    vm.insertItem = insertItem;
    vm.updateItem = updateItem;
    vm.deleteItem = deleteItem;

    vm.categoryTabSortOptions = {
      connectWith: ".categoryTabContainer",
      "items": "> * md-tab-item",
      "axis": "x",
      "stop": function(e, ui) {
        var newCategoryIndex = ui.item.sortable.dropindex;
        for (var i=newCategoryIndex; i<vm.categoryList.length; i++) {
          if (i === 0) {
           vm.categoryList[i].sortOrder = 0;
          } else {
            vm.categoryList[i].sortOrder = vm.categoryList[i - 1].sortOrder + 100;
          }
          vm.updateCategory(null, vm.categoryList[i]);
        }
      }
    };

    vm.itemSortOptions = {
      connectWith: ".itemContainer",
      "items": "> * md-list-item",
      "axis": "y",
      "stop": function(e, ui) {
        var newItemIndex = ui.item.sortable.dropindex;
        var items = ui.item.sortable.sourceModel;
        for (var i=newItemIndex; i<items.length; i++) {
          if (i === 0) {
            items[i].sortOrder = 0;
          } else {
            items[i].sortOrder = items[i - 1].sortOrder + 100;
          }
          vm.updateItem(items[i]);
        }
      }
    };

    activate();

    function activate() {

      var key = $stateParams.objectKey;

      loadVendor(key);
      loadCategories(key);

    }

    function loadVendor(key) {

      Vendors.get({objectKey: key}, success, error);

      function success(response) {
        vm.vendor = response || {};
      }

      function error(response) {
        $log.error(angular.toJson(response));
      }
    }

    function loadCategories(key) {

      Vendors.categories({objectKey: key}, success, error);

      function success(response) {
        var allItems = response.items || [];
        vm.categories = {};
        for (var i = 0; i < allItems.length; i++) {
          if (!allItems.hasOwnProperty(i)) {
            continue;
          }
          var categoryKey = allItems[i].key;
          var items = allItems[i].items;
          vm.categories[categoryKey] = allItems[i] || {};
          vm.categories[categoryKey].activeItems = [];
          vm.categories[categoryKey].archivedItems = [];
          for (var j in items) {
            if (!items.hasOwnProperty(j)) {
              continue;
            }
            if (items[j].archived) {
              vm.categories[categoryKey].archivedItems.push(items[j]);
            } else {
              vm.categories[categoryKey].activeItems.push(items[j]);
            }
          }
          //resortItems(categoryKey);
          vm.categories[categoryKey].activeItems = vm.categories[categoryKey].activeItems.sort(function(a, b) {
            return a.sortOrder - b.sortOrder;
          });
        }
        vm.categoryList = [];
        for (var i in vm.categories) {
          if (!vm.categories[i].archived) {
            vm.categoryList.push(vm.categories[i]);
          }
        }
        vm.categoryList = vm.categoryList.sort(function(a, b) {
          return a.sortOrder - b.sortOrder;
        });
      }

      function error(response) {
        $log.error(angular.toJson(response));
      }

    }

    function resortItems(categoryKey) {
      vm.categories[categoryKey].activeItems = vm.categories[categoryKey].activeItems.sort(function(a,b) {
        return a.name.localeCompare(b.name);
      }).sort(function(a, b) {
        if (a.active === b.active) return 0;
        return a.active ? -1 : 1;
      });
    }

    function addCategory() {
      /// show dialogue to create new category

      $mdDialog.show({
        locals: { vendorKey: vm.vendor.key },
        controller: CategoryDialogController,
        templateUrl: 'app/common/vendor/menu/vendor.category.dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true
      })
        .then(function (category) {
          if (angular.isUndefined(category)) { return; }
          category.items = [];
          vm.categories[category.key] = vm.categories;
          vm.categoryList.push(category);
        });

    }

    function updateCategory(form, category) {
      $log.info(angular.toJson(category));
      if (form !== null && !form.$valid) { return; }
      vm.categoryLoading = true;
      var params = { objectKey: category.key };
      VendorCategories.update(params, category, function() {
        vm.categoryLoading = false;
        showSuccess();
      }, function(error) {
        vm.categoryLoading = false;
        showError(error);
      });
    }

    function showSuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Saved!')
      );
    }

    function showError(error) {
      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(error.message || 'Something went wrong.')
      );
    }


    function deleteCategory() {

      showError({ message: 'Sorry, can\'t let you do that yet.' });

    }

    function editItem(category, item) {
      item = item || {category: category};

      $log.info(angular.toJson(item));

      /// show dialogue to create  new item

      $mdDialog.show({
        locals: {categories: vm.categories, item: item, vendorKey: vm.vendor.key},
        controller: ItemDialogController,
        templateUrl: 'app/common/vendor/menu/vendor.item.dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true
      })
        .then(function (item) {
          if (angular.isUndefined(item)) { return; }
          placeItem(item);
        });

    }


    function toggleItemActive(category, item) {
      VendorItems.update({objectKey: item.key}, item, function() {
        //resortItems(category.key);
      }, function() {
        $scope.errorMessage = "Unable to toggle item active state";
      });
    }

    function archiveItem(category, item, callback, shouldConfirm) {
      if (shouldConfirm === null || shouldConfirm === undefined) {
        shouldConfirm = true;
      }
      if (shouldConfirm) {
        var c = confirm("Are you sure you want to archive this item? This cannot be undone.");
        if (!c) {
          return;
        }
      }
      var updatedItem = Object.assign({}, item);
      updatedItem.archived = true;
      VendorItems.update({objectKey: item.key}, updatedItem, function() {
        item.archived = true;
        if (callback) {
          callback(true);
        }
      }, function() {
        $scope.errorMessage = "Unable to archive item";
        if (callback) {
          callback(false);
        }
      });
    }

    function archiveCategory(category) {
      var c = confirm("Are you sure you want to archive this category? All items in the category will be archived. The items can no longer be made available in the menu. This cannot be undone.");
      if (!c) {
        return;
      }
      var allItemsArchived = true;
      for (var i in category.activeItems) {
        (function(i) {
          archiveItem(category, category.activeItems[i], function(success) {
            if (!success) {
              allItemsArchived = false;
            }
          }, false);
        })(i);
      }
      if (!allItemsArchived) {
        $scope.errorMessage = "Unable to archive all items in cateogry. Category will not be archived.";
        return;
      }
      var updatedCategory = Object.assign({}, category);
      updatedCategory.archived = true;
      VendorCategories.update({objectKey: category.key}, updatedCategory, function() {
        category.archived = true;
      }, function() {
        $scope.errorMessage = "Unable to archive category";
      });
    }


    function placeItem(item) {

      /// replace if exists
      for (var i=0; i < vm.categories.length; i++){
        var category = vm.categories[i];
        var items = category.items;
        for (var j=0; j < items.length; j++) {
          var categoryItem = items[j];
          if (item.key === categoryItem.key) {
            /// if category is the same replace the object and return
            if (item.category.key === category.key) {
              category.items[j] = item;
              return;
            }
            /// otherwise remove the object
            items.splice(j, 1);
            addItem(item);
            return;
          }
        }
      }

      addItem(item);

    }

    function addItem(item) {
      /// append the item to the category because it didn't previously exist
      vm.categories[item.category.key].activeItems.push(item);
    }

    /* eslint-disable angular/controller-as */
    function CategoryDialogController($scope, $mdDialog, VendorCategories, vendorKey) {

      $scope.category = {};
      $scope.categoryLoading = false;

      $scope.onCategoryImageUpload = function(imageUrl) {
        $scope.category.imageUrl = imageUrl;
        $scope.$digest();
      };

      $scope.insert = function(form, category) {

        if (vm.categoryList.length > 0) {
          category.sortOrder = vm.categoryList[vm.categoryList.length-1].sortOrder + 100;
        }
        $scope.errorMessage = '';

        if (!form.$valid) { return; }
        var params = { vendorKey: vendorKey };

        $scope.categoryLoading = true;

        VendorCategories.insert(params, category, function(success) {
          $scope.categoryLoading = false;
          $mdDialog.hide(success);
        }, function (error) {
          $scope.categoryLoading = false;
          $scope.errorMessage = error.message || 'Something went wrong.';
        });


      };

      $scope.cancel = function() {
        $mdDialog.cancel();
      };

    }

    /* eslint-disable angular/controller-as */
    function ItemDialogController($log, $scope, $mdDialog, VendorItems, categories, item, vendorKey) {

      $scope.categories = categories;
      $scope.item = item;

      $scope.onItemImageUpload = function(imageUrl) {
        $scope.item.imageUrl = imageUrl;
        $scope.$digest();
      };

      $scope.useTemplate = function(template) {
        if (template !== null) {
          $scope.itemBackup = $scope.item;
          $scope.item.name = template.name;
          $scope.item.imageUrl = template.imageUrl;
          $scope.item.description = template.description;
        } else {
          $scope.item = $scope.itemBackup;
        }
      };

      $scope.searchItemTemplates = function(searchText) {
        return ItemTemplates.getAll({search: searchText}).$promise.then(function(response) {
          return response.items;
        });
      };

      if ($scope.item.templateKey) {
        ItemTemplates.get({objectKey: $scope.item.templateKey}, function(response) {
          $scope.selectedItem = response;
          $scope.useTemplate(response);
        });
      }

      $scope.hide = function() {
        $mdDialog.hide();
      };

      $scope.cancel = function() {
        $mdDialog.cancel();
      };

      $scope.save = function(form, item) {

        if (!form.$valid) { return; }

        $scope.itemLoading = true;

        item.currency = 'USD';

        function itemSuccess(response) {
          $scope.itemLoading = false;
          $mdDialog.hide(response);
        }

        function itemError(error) {
          $scope.itemLoading = false;
          $log.info(angular.toJson(error));
          $scope.errorMessage = error.message || 'Something went wrong.';
        }

        var key = item.key;
        if (angular.isUndefined(key)) {
          var insertParams = { vendorKey: vendorKey };
          VendorItems.insert(insertParams, item, itemSuccess, itemError);
        } else {
          var params = { objectKey: key };
          VendorItems.update(params, item, itemSuccess, itemError);
        }
      };
    }

    function insertItem(item) {
      $log.info(angular.toJson(item));
    }

    function updateItem(item) {
      VendorItems.update({objectKey: item.key}, item);
      $log.info(angular.toJson(item));
    }

    function deleteItem(item) {
      $log.info(angular.toJson(item));
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.vendor-selector', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.vendor-selector')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.vendor-selector', {
        url:'/vendor/vendor-selector',
        templateUrl:'app/vendor/vendor-selector/vendor.vendor-selector.html',
        controller:'VendorVendorSelectorController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.vendor.vendor-selector')
    .controller('VendorVendorSelectorController', VendorVendorSelectorController);


  VendorVendorSelectorController.$inject = ['$log', '$http', '$state', 'Auth', 'Accounts', 'Vendors', 'Toast'];

  function VendorVendorSelectorController($log, $http, $state, Auth, Accounts, Vendors, Toast) {
    var vm = this;

    Auth.$requireSignIn();

    vm.account = Accounts.me();
    vm.vendors = [];

    activate();

    vm.account.$promise.then(function(account) {
      loadVendors(account);
    });

    function loadVendors(account) {
      for (var i in account.vendors) {
        if (account.vendors.hasOwnProperty(i)) {
          (function (i) {
            Vendors.get({objectKey: account.vendors[i].key}, success, error);
          })(i);
        }
      }
    }

    function success(response) {
      vm.vendors.push(response);
    }

    function error(error) {
      $log.error(angular.toJson(error));
      Toast.error(error);
    }

    function activate() {
      $log.info('Activate VendorVendorSelectorController');
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.users', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.users')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.users', {
        url:'/users',
        templateUrl:'app/vendor/users/vendor.users.html',
        controller:'VendorUsersController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.vendor.users')
    .factory('VendorUsers', VendorUsers);

  VendorUsers.$inject = ['$resource', 'apiUrl'];

  function VendorUsers($resource, apiUrl) {

    var userUrl = apiUrl + '/accounts';
    var blockUrl = userUrl + '/:vendorKey/:accountKey/block';
    var removeUrl = userUrl + '/:vendorKey/:accountKey/remove';
    var unblockUrl = userUrl + '/:vendorKey/:accountKey/unblock';


    return $resource(userUrl, null,
      {
        block: { method: 'POST', url:blockUrl },
        remove: { method: 'DELETE', url:removeUrl},
        unblock: { method: 'POST', url:unblockUrl },
        get: { method: 'GET' },
        update: { method: 'PUT' },
        search: { method: 'GET' }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.users')
    .controller('VendorUsersController', VendorUsersController);

  VendorUsersController.$inject = ['$log', '$state', '$stateParams', 'VendorUsers', 'Toast'];

  function VendorUsersController($log, $state, $stateParams, VendorUsers, Toast) {

    var vm = this;

    vm.users = [];

    var vendor = $stateParams.objectKey;
    vm.vendor = vendor;

    if (!angular.isString(vendor)) {
      $state.go('auth.app');
    }

    vm.params = {
      vendor:vendor,
      type:'',
      limit:20,
      cursor:null
    };

    vm.loadingMore = false;

    vm.block = block;
    vm.remove = remove;
    vm.unblock = unblock;

    vm.loadUsers = loadUsers;
    vm.loadMoreUsers = loadMoreUsers;

    activate();

    function activate() {

      loadUsers();

    }

    function block(user) {
      action('block', user);
    }

    function remove(user) {
      var c = confirm("Are you sure you want to remove this user? They will have to be re-invited to be re-added again.");
      if (c) {
        action('remove', user);
      }
    }

    function unblock(user) {
      action('unblock', user);
    }

    function action(action, user) {

      if (!angular.isString(user.key)) {
        return;
      }
      VendorUsers[action]({vendorKey: vendor, accountKey: user.key }, null,  success, error);

      function success() {
        var verb = action + 'ed';
        Toast.success('Successfully ' + verb + ' ' + user.name);
        loadUsers(vm.currentCursor);
      }

      function error(error) {
        $log.error(angular.toJson(error));
        Toast.error(error);
      }

    }

    function loadUsers(cursor) {

      if (angular.isString(cursor)) {
        vm.params.cursor = cursor;
      } else {
        vm.params.cursor = null;
      }

      VendorUsers.search(vm.params, success, error);

      function success(response) {

        var items = response.items || [];
        var filtered = [];
        vm.currentCursor = response.nextPageToken || null;

        for (var i=0; i < items.length; i++) {
          var item = items[i];
          if (item.accountType !== 'Admin') {
            item.accountType = item.vendorAccountTypes[vm.vendor];
          }
          if (item.vendor !== undefined && item.vendor.key === vm.params.vendor) {
            filtered.push(item);
            continue;
          }
          for (var j=0; j < item.vendors.length; j++){
            var v = item.vendors[j];
            if (v.key === vm.params.vendor) {
              filtered.push(item);
            }
          }
        }

        if (vm.loadingMore) {
          vm.users = vm.users.concat(filtered);
          vm.loadingMore = false;
          return;
        }

        vm.users = filtered;


      }

      function error(response) {
        $log.info(angular.toJson(response));
      }


    }

    function loadMoreUsers() {
      if (vm.currentCursor === null || vm.loadingMore) {
        return;
      }
      vm.loadingMore = true;
      loadUsers(vm.currentCursor);
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.settings', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.settings')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.settings', {
        url:'/settings',
        templateUrl:'app/vendor/settings/vendor.settings.html',
        controller:'VendorSettingsController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.vendor.settings')
    .controller('VendorSettingsController', VendorSettingsController);

  VendorSettingsController.$inject = ['$log', '$location', '$http', '$state', '$stateParams', 'Auth', 'Accounts', 'Vendors', 'Toast'];

  function VendorSettingsController($log, $location, $http, $state, $stateParams, Auth, Accounts, Vendors, Toast) {


    var vm = this;

    Auth.$requireSignIn();

    vm.logout = logout;
    vm.save = save;
    vm.updateEmail = updateEmail;
    vm.grabToken = grabToken;

    vm.account = Accounts.me();
    vm.vendor = Vendors.get({objectKey: $stateParams.objectKey});
    var firebaseOptions = firebase.apps[0].options;
    vm.stripeURL = firebaseOptions.stripeAuthURL;
    vm.stripeURL += "&stripe_user[business_type]=company";
    vm.stripeURL += "&state=" + $stateParams.objectKey;
    vm.stripeURL += "&redirect_uri=https://" + $location.host() + "/stripe";
    activate();

    function save(form, account) {
      if (!form.$valid) {
        return;
      }

      Accounts.update({ objectKey: account.key }, account, success, error);

    }

    function success(response) {
      vm.account = response;
      Toast.success('Successfully updated account!');
    }

    function error(error) {
      $log.error(angular.toJson(error));
      Toast.error(error);
    }

    function updateEmail(form, account) {

      if (!form.$valid) {
        return;
      }

      Auth.$updateEmail(account.email).then(function() {
        Accounts.updateEmail({ objectKey: account.key }, null, success, error);
        $log.info("Email changed successfully!");
      }).catch(function(error) {
        $log.error("Error: ", error);
        Toast.error(error);
      });

    }

    function grabToken() {
      Auth.$requireSignIn().then(function(currentAuth) {
        currentAuth.getToken(false).then(function(token) {
          vm.token = token;
        });
      });
    }

    function activate() {
      $log.info('Activate VendorSettingsController');
    }

    function logout() {

      $http.defaults.headers.common.Authorization = '';
      Auth.$signOut();
      $state.go('auth.login');

    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.orders', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.orders')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.orders', {
        url:'/orders',
        templateUrl:'app/vendor/orders/vendor.orders.html',
        controller:'VendorOrdersController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.vendor.orders')
    .factory('Orders', Orders);

  Orders.$inject = ['$resource', 'apiUrl'];

  function Orders($resource, apiUrl) {

    var orderUrl = apiUrl + '/orders';
    var serveUrl = orderUrl + '/:objectKey/serve';


    return $resource(orderUrl, null,
      {
        get: { method: 'GET' },
        serve: { method: 'PUT', url:serveUrl },
        search: { method: 'GET' }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.orders')
    .controller('VendorOrdersController', VendorOrdersController);

  VendorOrdersController.$inject = ['$log', '$stateParams', 'Orders'];

  function VendorOrdersController($log, $stateParams, Orders) {

    var vm = this;
    vm.orders = [];

    var vendorKey = $stateParams.objectKey;

    vm.params = {
      vendor: vendorKey,
      limit:20,
      cursor:null
    };

    vm.loadingMore = false;

    vm.loadOrders = loadOrders;
    vm.loadMoreOrders = loadMoreOrders;

    activate();

    function activate() {

      loadOrders();

    }

    // function action(action, user) {
    //
    //   if (!angular.isString(user.key)) {
    //     return;
    //   }
    //   VendorUsers[action]({objectKey: user.key }, null,  success, error);
    //
    //   function success() {
    //     var verb = action + 'ed';
    //     Toast.success('Successfully ' + verb + ' ' + user.name);
    //     loadUsers(vm.currentCursor);
    //   }
    //
    //   function error(error) {
    //     $log.error(angular.toJson(error));
    //     Toast.error(error);
    //   }
    //
    // }

    function loadOrders(cursor) {

      if (angular.isString(cursor)) {
        vm.params.cursor = cursor;
      } else {
        vm.params.cursor = null;
      }

      Orders.search(vm.params, success, error);

      function success(response) {

        var items = response.items || [];
        vm.currentCursor = response.nextPageToken || null;

        if (vm.loadingMore) {
          vm.orders = vm.orders.concat(items);
          vm.loadingMore = false;
          return;
        }

        vm.orders = items;

        if (vm.orders.length === 0) {
          vm.message = "No orders.";
        }

      }

      function error(response) {
        vm.loadingMore = false;
        $log.info(angular.toJson(response));
      }


    }

    function loadMoreOrders() {
      if (vm.currentCursor === null || vm.loadingMore) {
        return;
      }
      vm.loadingMore = true;
      loadOrders(vm.currentCursor);
    }


  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.menu', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.menu')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.menu', {
        url:'/menu',
        templateUrl:'app/common/vendor/menu/vendor.menu.html',
        controller:'VendorMenuController',
        controllerAs:'vm'
      });

  }

})();



(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.main', []);

})();

(function () {
  'use strict';

  angular
    .module('semy.vendor.main')
    .run(run);

  run.$inject = ['$log', '$transitions', 'targetService', '$trace'];

  function run($log, $transitions, targetService, $trace) {

    $trace.enable('TRANSITION', 'VIEWCONFIG');

    $transitions.onStart( { to: 'vendor.**' }, function(trans) {

      var $state = trans.router.stateService;
      var auth = trans.injector().get('Auth');

      // If the user is not authenticated
      return auth.$requireSignIn().catch(function() {
        targetService.target = trans.$to();
        return $state.target('auth.login');
      });

    });

    $log.debug('Authenticated runBlock end');

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.main')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    // ahFzfnNlbXktcHJvZHVjdGlvbnIZCxIMVmVuZG9yRW50aXR5GICAgIDb8Y4JDA
    $stateProvider
      .state('vendor', {
        url:'/vendor/:objectKey',
        templateUrl:'app/vendor/main/vendor.main.html',
        controller:'VendorMainController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.vendor.main')
    .controller('VendorMainController', VendorMainController);

  VendorMainController.$inject = ['$log', '$stateParams', 'Vendors', 'Accounts'];

  function VendorMainController($log, $stateParams, Vendors, Accounts) {

    var vm = this;

    vm.menu = [
      {
        sref : 'vendor.dashboard',
        title: 'Dashboard',
        icon: 'apps'
      },
      {
        sref : 'vendor.detail',
        title: 'Profile',
        icon: 'edit'
      },
      {
        sref : 'vendor.menu',
        title: 'Menu',
        icon: 'local_drink'
      },
      {
        sref : 'vendor.orders',
        title: 'Orders',
        icon: 'receipt'
      },
      {
        sref : 'vendor.users',
        title: 'Users',
        icon: 'supervisor_account'
      },
      {
        sref : 'vendor.invitations',
        title: 'Invitations',
        icon: 'person_add'
      }
    ];
    vm.settings = [
      {
        sref : 'vendor.settings',
        title: 'Settings',
        icon: 'settings'
      }
    ];

    activate();

    function activate() {
      $log.info('Activate VendorMainController');

      var vendorKey = $stateParams.objectKey;
      if (!angular.isString(vendorKey)) {
        return;
      }

      vm.vendor = Vendors.get({ objectKey: vendorKey });
      vm.account = Accounts.me({}, function(account) {
        if (account.accountType !== 'Admin' && account.vendorAccountTypes[vendorKey] === 'User') {
          vm.isUser = true;
          vm.vendors = [];
          for (var i in account.vendors) {
            if (account.vendors.hasOwnProperty(i)) {
              (function (i) {
                if (account.vendors[i].key === vendorKey || account.vendorAccountTypes[account.vendors[i].key] === 'User') {
                  return;
                }
                Vendors.get({objectKey: account.vendors[i].key}, function(vendor) {vm.vendors.push(vendor);});
              })(i);
            }
          }
        }
      });

    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.invitations', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.invitations')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.invitations', {
        url:'/invitations',
        templateUrl:'app/vendor/invitations/vendor.invitations.html',
        controller:'VendorInvitationsController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.vendor.invitations')
    .factory('Invitations', Invitations);

  Invitations.$inject = ['$resource', 'apiUrl'];

  function Invitations($resource, apiUrl) {

    var invitationUrl = apiUrl + '/invitations/:objectKey';
    var resendUrl = invitationUrl + '/resend';
    var cancelUrl = invitationUrl + '/cancel';


    return $resource(invitationUrl, null,
      {
        insert: { method: 'POST' },
        resend: { method: 'PUT', url:resendUrl },
        cancel: { method: 'PUT', url:cancelUrl },
        get: { method: 'GET' },
        search: { method: 'GET' }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('semy.vendor.invitations')
    .controller('VendorInvitationsController', VendorInvitationsController);

  VendorInvitationsController.$inject = ['$log', '$stateParams', '$mdDialog', '$document', 'Invitations', 'Toast'];

  function VendorInvitationsController($log, $stateParams, $mdDialog, $document, Invitations, Toast) {

    var vm = this;

    vm.invitations = [];

    var vendor = $stateParams.objectKey;

    vm.params = {
      vendor: vendor,
      filter: 'Sent',
      limit: 20,
      cursor: null
    };

    vm.loadingMore = false;

    vm.resend = resend;
    vm.cancel = cancel;
    vm.inviteUser = inviteUser;

    vm.loadInvitations = loadInvitations;
    vm.loadMoreInvitations = loadMoreInvitations;

    activate();

    function activate() {

      loadInvitations();

    }

    function resend(invitation) {
      action('resend', invitation);
    }

    function cancel(invitation) {
      action('cancel', invitation);
    }

    function action(action, invitation) {

      if (!angular.isString(invitation.key)) {
        return;
      }
      Invitations[action]({objectKey: invitation.key}, null, success, error);

      function success() {

        var verb = action === 'resend' ? 'resent' : 'cancelled';
        Toast.success('Successfully ' + verb + ' invitation to ' + invitation.email);
        loadInvitations(vm.currentCursor);
      }

      function error(error) {
        $log.error(angular.toJson(error));
        Toast.error(error);
      }

    }

    function loadInvitations(cursor) {

      if (angular.isString(cursor)) {
        vm.params.cursor = cursor;
      } else {
        vm.params.cursor = null;
      }

      Invitations.search(vm.params, success, error);

      function success(response) {

        var items = response.items || [];
        vm.currentCursor = response.nextPageToken || null;

        if (vm.loadingMore) {
          vm.invitations = vm.invitations.concat(items);
          vm.loadingMore = false;
          return;
        }

        vm.invitations = items;

        vm.message = '';
        if (vm.invitations.length === 0) {
          vm.message = 'There are no invitations.';
        }

      }

      function error(response) {
        $log.info(angular.toJson(response));
      }


    }

    function loadMoreInvitations() {
      if (vm.currentCursor === null || vm.loadingMore) {
        return;
      }
      vm.loadingMore = true;
      loadInvitations(vm.currentCursor);
    }

    function inviteUser() {

      $mdDialog.show({
        locals: { vendorKey: vendor },
        controller: InvitationDialogController,
        templateUrl: 'app/vendor/invitations/vendor.invitation.dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true
      })
        .then(function (invitation) {
          if (angular.isUndefined(invitation)) {
            return;
          }
          vm.invitations = vm.invitations || [];
          vm.invitations.push(invitation);
          Toast.success('Sent invitation to ' + invitation.email + '!');
        });

    }

    /* eslint-disable angular/controller-as */
    function InvitationDialogController($log, $scope, $mdDialog, Invitations, vendorKey) {

      $scope.accountTypes = [ "Manager", "User" ];
      $scope.invitation = {
        vendor: { key: vendorKey }
      };

      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      $scope.invite = function (form, invitation) {

        if (!form.$valid) {
          return;
        }

        $scope.itemLoading = true;

        function itemSuccess(response) {
          $scope.itemLoading = false;
          $mdDialog.hide(response);
        }

        function itemError(error) {
          $scope.itemLoading = false;
          $log.info(angular.toJson(error));
          error = error.data;
          $scope.errorMessage = error.message || 'Something went wrong.';
        }

        Invitations.insert(null, invitation, itemSuccess, itemError);

      };
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.detail', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.detail')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.detail', {
        url:'/detail',
        templateUrl:'app/common/vendor/detail/vendor.detail.html',
        controller:'VendorDetailController',
        controllerAs:'vm'
      });

  }

})();



(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.vendor.dashboard', []);

})();

(function () {
  'use strict';

  angular
    .module('semy.vendor.dashboard')
    .run(Run);

  Run.$inject = ['$log'];

  function Run($log) {

    $log.info('semy.vendor.dashboard running.');

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.vendor.dashboard')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('vendor.dashboard', {
        url:'/dashboard',
        templateUrl:'app/vendor/dashboard/vendor.dashboard.html',
        controller:'VendorDashboardController',
        controllerAs:'vm'
      });

  }

})();



(function () {
  'use strict';

  angular
    .module('semy.vendor.dashboard')
    .controller('VendorDashboardController', VendorDashboardController);

  VendorDashboardController.$inject = ['$log', '$stateParams', 'Vendors'];

  function VendorDashboardController($log, $stateParams, Vendors) {

    var vm = this;

    vm.datapoints = [
      {"x": "11-8-2017", "top-1": 260 },
      {"x": "11-9-2017", "top-1": 277 },
      {"x": "11-10-2017", "top-1": 310 },
      {"x": "11-11-2017", "top-1": 378 },
      {"x": "11-12-2017", "top-1": 350 }
    ];

    vm.datacolumns = [
      {"id": "top-1", "type": "bar", "name": "All Sales"}];

    vm.datax = {"id": "x"};

    activate();

    function activate() {

      $log.info('Activate VendorMainController');

      var vendorKey = $stateParams.objectKey;
      if (!angular.isString(vendorKey)) {
        return;
      }

      vm.vendor = Vendors.get({objectKey: vendorKey});

    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.vendors', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.vendors')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin.vendors', {
        url:'/admin/vendors',
        templateUrl:'app/admin/vendors/admin.vendors.html',
        controller:'VendorsController',
        controllerAs:'vm'
      })
      .state('admin.vendorDetail', {
        url:'/admin/vendors/:objectKey/detail',
        templateUrl:'app/common/vendor/detail/vendor.detail.html',
        controller:'VendorDetailController',
        controllerAs:'vm'
      })
      .state('admin.vendorMenu', {
        url:'/admin/vendors/:objectKey/menu',
        templateUrl:'app/common/vendor/menu/vendor.menu.html',
        controller:'VendorMenuController',
        controllerAs:'vm'
      })
      .state('admin.vendorSettings', {
        url:'/admin/vendors/:objectKey/admin-settings',
        templateUrl:'app/admin/vendors/admin.vendor.settings.html',
        controller:'AdminVendorSettingsController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.admin.vendors')
    .factory('Vendors', Vendors);

  Vendors.$inject = ['$resource', 'apiUrl'];

  function Vendors($resource, apiUrl) {

    var root = apiUrl + '/vendors/';
    var url = root + ':objectKey';
    var items = url + '/categories?scope=items';
    var connectUrl = apiUrl + '/stripe/vendor/:objectKey';
    var dashboardLinkUrl = apiUrl + '/stripe/vendor/:objectKey/link';
    var settingsUrl = url + '/adminSettings';

    return $resource(url, null,
      {

        get: { method: 'GET' },
        insert: { method: 'POST' },
        connectToStripe: { method: 'POST', url: connectUrl },
        dashboardLink: { method: 'GET', url: dashboardLinkUrl },
        update: { method:'PUT' },
        search: { method: 'GET' },
        categories: { method:'GET', url: items },
        stripeOauth: { method:'POST', url:  url + "/stripe/:stripeToken"},
        adminSettings: {method: 'GET', url: settingsUrl },
        updateAdminSettings: {method: 'POST', url: settingsUrl }

      });
  }

})();

(function () {
  'use strict';

  angular
    .module('semy.admin.vendors')
    .controller('VendorsController', VendorsController);

  VendorsController.$inject = ['$log', 'Vendors', 'Accounts'];

  function VendorsController($log, Vendors, Accounts) {

    var vm = this;

    vm.account = Accounts.me();

    /// initialize
    vm.vendors = [];
    vm.params = {
      'active': true,
      'search': '',
      'limit': 20
    };

    vm.loadingMore = false;
    vm.currentCursor = null;

    vm.loadVendors = loadVendors;
    vm.loadMoreVendors = loadMoreVendors;

    activate();

    function activate() {
      loadVendors();
    }

    function loadMoreVendors() {

      if (vm.currentCursor === null || vm.loadingMore) {
        return;
      }

      vm.loadingMore = true;
      loadVendors(vm.currentCursor);

    }

    function loadVendors(cursor) {

      if (angular.isString(vm.search) && vm.search.length > 0) {
        vm.params.search = vm.search;
      }

      if (angular.isString(cursor)) {
        vm.params.cursor = cursor;
      } else {
        delete vm.params.cursor;
      }

      Vendors.search(vm.params, success, error);

      function success(response) {

        vm.currentCursor = response.nextPageToken || null;
        var items = response.items || [];
        if (vm.loadingMore) {
          vm.vendors = vm.vendors.concat(items);
          vm.loadingMore = false;
          return;
        }
        vm.vendors = items;
      }

      function error(response) {
        vm.loadingMore = false;
        vm.currentCursor = null;
        $log.error(angular.toJson(response));
      }

    }
  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin', []);

})();

(function () {
  'use strict';

  angular
    .module('semy.admin')
    .controller('AdminVendorSettingsController', AdminVendorSettingsController);

  AdminVendorSettingsController.$inject = ['$scope', '$log', '$stateParams', '$state', 'Vendors', '$mdToast'];

  function AdminVendorSettingsController($scope, $log, $stateParams, $state, Vendors, $mdToast) {

    var vm = this;

    /// initialize
    vm.loading = false;
    vm.save = save;

    vm.documentUpload = function (fileUrl) {
      vm.settings.documentUrl = fileUrl;
      $scope.$digest();
    };

    vm.generateDocFilename = function(filename) {
      return (Math.random() * new Date().getTime()).toString(16) + "-" + filename;
    };

    activate();

    function activate() {

      var key = $stateParams.objectKey;

      if (angular.isUndefined(key)) {
        return;
      }

      vm.vendorKey = key;
      vm.loading = true;
      Vendors.adminSettings({objectKey: key}, success, error);

      function success(response) {
        vm.loading = false;
        vm.settings = response;
      }

      function error(response) {
        vm.loading = false;
        $log.error(angular.toJson(response));
      }

    }

    function save(form) {

      if (!form.$valid) {
        showError({message: "Form not valid"});
        return;
      }

      var feedDiscountPercentage = vm.settings.feeDiscountPercentage;
      if (feedDiscountPercentage && !feedDiscountPercentage.match(/(0+|1)\.\d+/)) {
        showError({message: "Not a valid percentage for the fee discount, must be a decimal number EG 0.25 for 25%"});
        return;
      }

      vm.loading = true;

      var params = {objectKey: vm.settings.vendorKey};
      Vendors.updateAdminSettings(params, vm.settings, success, error);

      function success(response) {
        vm.settings = response;
        $state.go('admin.vendor.settings', {objectKey: vm.settings.vendorKey}, {notify: false});
        vm.loading = false;
        showSuccess();
      }

      function error(error) {
        vm.loading = false;
        showError(error);
        $log.error(angular.toJson(error));
      }

    }

    function showSuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Saved!')
      );
    }

    function showError(error) {
      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(error.message || 'Something went wrong.')
      );
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.vendors')
    .factory('VendorItems', VendorItems);

  VendorItems.$inject = ['$resource', 'apiUrl'];

  function VendorItems($resource, apiUrl) {

    var url = apiUrl + '/vendors/items/:objectKey';
    var insert = apiUrl + '/vendors/:vendorKey/items';

    return $resource(url, null,
      {

        get: { method: 'GET' },
        insert: { method: 'POST', url:insert },
        update: { method:'PUT' }

      });
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.vendors')
    .factory('VendorCategories', VendorCategories);

  VendorCategories.$inject = ['$resource', 'apiUrl'];

  function VendorCategories($resource, apiUrl) {

    var root = apiUrl + '/vendors/categories/';
    var url = root + ':objectKey';
    var insert = apiUrl + '/vendors/:vendorKey/categories';

    return $resource(url, null,
      {

        get: { method: 'GET' },
        insert: { method: 'POST', url:insert },
        update: { method:'PUT' }

      });
  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.users', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.users')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin.users', {
        url:'/admin/users',
        templateUrl:'app/admin/users/admin.users.html',
        controller:'UsersController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.admin.users')
    .factory('Users', Users);

  Users.$inject = ['$resource', 'apiUrl'];

  function Users($resource, apiUrl) {

    var userUrl = apiUrl + '/users';
    var blockUrl = userUrl + '/:objectKey/block';
    var unblockUrl = userUrl + '/:objectKey/unblock';


    return $resource(userUrl, null,
      {
        block: { method: 'POST', url:blockUrl },
        unblock: { method: 'POST', url:unblockUrl },
        get: { method: 'GET' },
        update: { method: 'PUT' },
        search: { method: 'GET' }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.users')
    .controller('UsersController', UsersController);

  UsersController.$inject = ['$log', 'Users', 'Toast'];

  function UsersController($log, Users, Toast) {

    var vm = this;

    vm.users = [];

    vm.params = {
      type:'User',
      limit:20,
      cursor:null
    };

    vm.loadingMore = false;

    vm.block = block;
    vm.unblock = unblock;

    vm.loadUsers = loadUsers;
    vm.loadMoreUsers = loadMoreUsers;

    activate();

    function activate() {

      loadUsers();

    }

    function block(user) {
      action('block', user);
    }

    function unblock(user) {
      action('unblock', user);
    }

    function action(action, user) {

      if (!angular.isString(user.key)) {
        return;
      }
      Users[action]({objectKey: user.key }, null,  success, error);

      function success() {
        var verb = action + 'ed';
        Toast.success('Successfully ' + verb + ' ' + user.name);
        loadUsers(vm.currentCursor);
      }

      function error(error) {
        $log.error(angular.toJson(error));
        Toast.error(error);
      }

    }

    function loadUsers(cursor) {

      if (angular.isString(cursor)) {
        vm.params.cursor = cursor;
      } else {
        vm.params.cursor = null;
      }

      Users.search(vm.params, success, error);

      function success(response) {

        var items = response.items || [];
        vm.currentCursor = response.nextPageToken || null;

        if (vm.loadingMore) {
          vm.users = vm.users.concat(items);
          vm.loadingMore = false;
          return;
        }

        vm.users = items;

      }

      function error(response) {
        $log.info(angular.toJson(response));
      }


    }

    function loadMoreUsers() {
      if (vm.currentCursor === null || vm.loadingMore) {
        return;
      }
      vm.loadingMore = true;
      loadUsers(vm.currentCursor);
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.settings', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.settings')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin.settings', {
        url:'/admin/settings',
        templateUrl:'app/admin/settings/admin.settings.html',
        controller:'AdminSettingsController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.admin.settings')
    .controller('AdminSettingsController', AdminSettingsController);


  AdminSettingsController.$inject = ['$log', '$http', '$state', 'Auth', 'Accounts', 'Toast'];

  function AdminSettingsController($log, $http, $state, Auth, Accounts, Toast) {


    var vm = this;

    Auth.$requireSignIn();

    vm.logout = logout;
    vm.save = save;
    vm.updateEmail = updateEmail;
    vm.grabToken = grabToken;

    vm.account = Accounts.me();


    activate();

    function save(form, account) {
      if (!form.$valid) {
        return;
      }

      Accounts.update({ objectKey: account.key }, account, success, error);

    }

    function success(response) {
      vm.account = response;
      Toast.success('Successfully updated account!');
    }

    function error(error) {
      $log.error(angular.toJson(error));
      Toast.error(error);
    }

    function updateEmail(form, account) {

      if (!form.$valid) {
        return;
      }

      Auth.$updateEmail(account.email).then(function() {
        Accounts.updateEmail({ objectKey: account.key }, null, success, error);
        $log.info("Email changed successfully!");
      }).catch(function(error) {
        $log.error("Error: ", error);
        Toast.error(error);
      });

    }

    function grabToken() {
      Auth.$requireSignIn().then(function(currentAuth) {
        currentAuth.getToken(false).then(function(token) {
          vm.token = token;
        });
      });
    }

    function activate() {
      $log.info('Activate VendorSettingsController');
    }

    function logout() {

      $http.defaults.headers.common.Authorization = '';
      Auth.$signOut();
      $state.go('auth.login');

    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.main', []);

})();

(function () {
  'use strict';

  angular
    .module('semy.admin.main')
    .run(run);

  run.$inject = ['$log', '$transitions', 'targetService', '$trace'];

  function run($log, $transitions, targetService, $trace) {

    $trace.enable('TRANSITION', 'VIEWCONFIG');

    $transitions.onStart( { to: 'admin.**' }, function(trans) {

      var $state = trans.router.stateService;
      var auth = trans.injector().get('Auth');

      // If the user is not authenticated
      return auth.$requireSignIn().catch(function() {
        targetService.target = trans.$to();
        return $state.target('auth.login');
      });

    });

    $log.debug('Authenticated runBlock end');

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.main')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin', {
        url:'',
        templateUrl:'app/admin/main/admin.main.html',
        controller:'AdminMainController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.admin.main')
    .controller('AdminMainController', AdminMainController);

  AdminMainController.$inject = ['$log'];

  function AdminMainController($log) {

    var vm = this;

    vm.menu = [
      {
        sref : 'admin.dashboard',
        title: 'Dashboard',
        icon: 'apps'
      },
      {
        sref : 'admin.vendors',
        title: 'Vendors',
        icon: 'local_drink'
      },
      {
        sref : 'admin.users',
        title: 'Users',
        icon: 'supervisor_account'
      },
      {
        sref : 'admin.itemTemplates',
        title: 'Item Templates',
        icon: 'local_drink'
      }
    ];
    vm.settings = [
      {
        sref : 'admin.settings',
        title: 'Settings',
        icon: 'settings'
      },
      {
        sref : 'admin.globalSettings',
        title : "Global Settings",
        icon: 'settings'
      }
    ];

    activate();

    function activate() {
      $log.info('Activate MainController');
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.item-templates', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.item-templates')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin.itemTemplates', {
        url:'/admin/item/templates/',
        templateUrl:'app/admin/item-templates/admin.item-templates.html',
        controller:'AdminItemTemplatesController',
        controllerAs:'vm'
      })
      .state('admin.itemTemplatesEdit', {
        url:'/admin/item/templates/:objectKey',
        templateUrl:'app/admin/item-templates/admin.item-templates.edit.html',
        controller:'AdminItemTemplatesEditController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.admin.item-templates')
    .factory('ItemTemplates', ItemTemplates);

  ItemTemplates.$inject = ['$resource', 'apiUrl'];

  function ItemTemplates($resource, apiUrl) {

    var url = apiUrl + '/items/templates';

    return $resource(url, null,
      {

        get: { method: 'GET', url: url + "/:objectKey" },
        update: { method: 'PUT', url: url + "/:objectKey" },
        insert: { method: 'POST' },
        getAll: { method: 'GET'}

      });
  }

})();

(function () {
  'use strict';

  angular
    .module('semy.admin.item-templates')
    .controller('AdminItemTemplatesEditController', AdminItemTemplatesEditController);

  AdminItemTemplatesEditController.$inject = ['$log', '$stateParams', '$state', '$mdToast', 'ItemTemplates'];

  function AdminItemTemplatesEditController($log, $stateParams, $state, $mdToast, ItemTemplates) {

    var vm = this;

    /// initialize
    vm.loading = false;

    activate();

    vm.itemTemplate = {categories: [], values: {}};

    var lastSearchTimeout = null;
    vm.searchItemTemplates = function() {
      if (lastSearchTimeout !== null) {
        clearTimeout(lastSearchTimeout);
        lastSearchTimeout = null;
      }
      lastSearchTimeout = setTimeout(function () {
        ItemTemplates.getAll({search: vm.search}, success, error);
      }, 250);
    };

    vm.newCategory = function() {
      vm.itemTemplate.categories.push("New Category");
    };

    vm.categoryChange = function() {
      var categories = [];
      for (var i in vm.itemTemplate.categories) {
        if (vm.itemTemplate.categories[i] !== "") {
          categories.push(vm.itemTemplate.categories[i]);
        }
      }
      vm.itemTemplate.categories = categories;
    };

    vm.newValue = function() {
      var key = prompt("Enter a key for the value (EG. ABV, IBU)");
      if (key) {
        vm.itemTemplate.values[key] = "";
      }
    };

    vm.removeValue = function(key) {
      delete vm.itemTemplate.values[key];
    };

    function success(response) {
      vm.loading = false;
      vm.itemTemplate = response;
    }

    function error(response) {
      vm.loading = false;
      $log.error(angular.toJson(response));
    }

    function activate() {
      if ($stateParams.objectKey) {
        vm.loading = true;
        ItemTemplates.get({objectKey: $stateParams.objectKey}, success, error);
      }
    }

    function showSuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Saved!')
      );
    }

    function showError(error) {
      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(error.message || 'Something went wrong.')
      );
    }

    vm.save = function (form) {

      if (!form.$valid) {
        return;
      }

      vm.loading = true;

      if (angular.isDefined(vm.itemTemplate.key)) {
        var params = {objectKey: vm.itemTemplate.key};
        ItemTemplates.update(params, vm.itemTemplate, success, error);
      } else {
        ItemTemplates.insert(vm.itemTemplate, success, error);
      }

      function success(response) {
        vm.itemTemplate = response;
        $state.go('admin.itemTemplateEdit', {objectKey: vm.itemTemplate.key}, {notify: false});
        vm.loading = false;
        showSuccess();
      }

      function error(error) {
        vm.loading = false;
        showError(error);
        $log.error(angular.toJson(error));
      }

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('semy.admin.item-templates')
    .controller('AdminItemTemplatesController', AdminItemTemplatesController);

  AdminItemTemplatesController.$inject = ['$log', '$stateParams', '$state', '$mdToast', 'ItemTemplates'];

  function AdminItemTemplatesController($log, $stateParams, $state, $mdToast, ItemTemplates) {

    var vm = this;

    /// initialize
    vm.loading = false;
    vm.loadingMore = false;
    vm.done = false;

    vm.loadMore = function() {
      if (vm.loadingMore || vm.done) {
        return;
      }
      vm.loadingMore = true;
      ItemTemplates.getAll({search: vm.search, cursor: vm.nextPageToken}, function(response) {
        if (vm.itemTemplates) {
          vm.itemTemplates = vm.itemTemplates.concat(response.items);
        } else {
          vm.itemTemplates = response.items;
        }
        if (!angular.isString(response.nextPageToken)) {
          vm.done = true;
        }
        vm.nextPageToken = response.nextPageToken;
        vm.loadingMore = false;
      });
    };

    activate();

    var lastSearchTimeout = null;
    vm.searchItemTemplates = function() {
      if (lastSearchTimeout !== null) {
        clearTimeout(lastSearchTimeout);
        lastSearchTimeout = null;
      }
      lastSearchTimeout = setTimeout(function () {
        ItemTemplates.getAll({search: vm.search}, success, error);
      }, 250);
    };

    function success(response) {
      vm.loading = false;
      vm.itemTemplates = response.items;
      vm.nextPageToken = response.nextPageToken;
    }

    function error(response) {
      vm.loading = false;
      $log.error(angular.toJson(response));
    }

    function activate() {
      vm.loading = true;
      //ItemTemplates.getAll({}, success, error);
    }

    function showSuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Saved!')
      );
    }

    function showError(error) {
      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(error.message || 'Something went wrong.')
      );
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.global', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.global')
    .factory('AppConfig', AppConfig);

  AppConfig.$inject = ['$resource', 'apiUrl'];

  function AppConfig($resource, apiUrl) {

    var url = apiUrl + '/appConfig/';

    return $resource(url, null,
      {

        get: { method: 'GET' },
        update: { method: 'PUT' }

      });
  }

})();

(function () {
  'use strict';

  angular
    .module('semy.admin.global')
    .controller('AdminGlobalSettingsController', AdminGlobalSettingsController);

  AdminGlobalSettingsController.$inject = ['$log', '$stateParams', '$state', 'AppConfig', '$mdToast'];

  function AdminGlobalSettingsController($log, $stateParams, $state, AppConfig, $mdToast) {

    var vm = this;

    /// initialize
    vm.loading = false;
    vm.save = save;

    activate();

    function activate() {

      vm.loading = true;
      AppConfig.get({}, success, error);

      function success(response) {
        vm.loading = false;
        vm.config = response;
      }

      function error(response) {
        vm.loading = false;
        $log.error(angular.toJson(response));
      }

    }

    function save(form) {

      if (!form.$valid) {
        showError({message: "Form not valid"});
        return;
      }

      function validatePercentage(percentage) {
        if (percentage === null || !percentage.match(/(0+|1)\.\d+/)) {
          showError({message: "Not a valid percentage, must be a decimal number EG 0.25 for 25%"});
          return false;
        }
        return true;
      }
      if (!validatePercentage(vm.config.percentagePriceFee) || !validatePercentage(vm.config.tipPercentage)) {
        return;
      }

      vm.loading = true;

      AppConfig.update({}, vm.config, success, error);

      function success(response) {
        vm.config = response;
        $state.go('admin.global.settings', {}, {notify: false});
        vm.loading = false;
        showSuccess();
      }

      function error(error) {
        vm.loading = false;
        showError(error);
        $log.error(angular.toJson(error));
      }

    }

    function showSuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Saved!')
      );
    }

    function showError(error) {
      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(error.message || 'Something went wrong.')
      );
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.global')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin.globalSettings', {
        url:'/admin/global/settings',
        templateUrl:'app/admin/global/admin.global.settings.html',
        controller:'AdminGlobalSettingsController',
        controllerAs:'vm'
      });

  }

})();



(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.admin.dashboard', []);

})();

(function () {
  'use strict';

  angular
    .module('semy.admin.dashboard')
    .run(Run);

  Run.$inject = ['$log'];

  function Run($log) {

    $log.info('semy.admin.dashboard running.');

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.admin.dashboard')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('admin.dashboard', {
        url:'/admin/dashboard',
        templateUrl:'app/admin/dashboard/admin.dashboard.html',
        controller:'AdminDashboardController',
        controllerAs:'vm'
      });

  }

})();



(function () {
  'use strict';

  angular
    .module('semy.admin.dashboard')
    .controller('AdminDashboardController', AdminDashboardController);

  AdminDashboardController.$inject = [];

  function AdminDashboardController() {

    var vm = this;

    var colors = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935',
      '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f8bbd0',
      '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f',
      '#ff80ab', '#ff4081', '#f50057', '#c51162', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc',
      '#9c27b0', '#8e24aa', '#7b1fa2', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff',
      '#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#4527a0',
      '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#c5cae9', '#9fa8da', '#7986cb',
      '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe',
      '#3d5afe', '#304ffe', '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3',
      '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff',
      '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd',
      '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#e0f7fa', '#b2ebf2', '#80deea',
      '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff',
      '#18ffff', '#00e5ff', '#00b8d4', '#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a',
      '#009688', '#00897b', '#00796b', '#00695c', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5',
      '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c',
      '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#f1f8e9', '#dcedc8',
      '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e',
      '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775',
      '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41',
      '#c6ff00', '#aeea00', '#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b',
      '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600',
      '#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000',
      '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#fff3e0', '#ffe0b2',
      '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100',
      '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65',
      '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40',
      '#ff3d00', '#dd2c00', '#d7ccc8', '#bcaaa4', '#795548', '#d7ccc8', '#bcaaa4', '#8d6e63',
      '#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#cfd8dc',
      '#b0bec5', '#78909c'];

    vm.colorTiles = (function() {
      var tiles = [];
      for (var i = 0; i < 46; i++) {
        tiles.push({
          color: randomColor(),
          colspan: randomSpan(),
          rowspan: randomSpan()
        });
      }
      return tiles;
    })();

    function randomColor() {
      return colors[Math.floor(Math.random() * colors.length)];
    }

    function randomSpan() {
      var r = Math.random();
      if (r < 0.8) {
        return 1;
      } else if (r < 0.9) {
        return 2;
      } else {
        return 3;
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('semy.vendor')
    .run(Run);

  Run.$inject = ['$log'];

  function Run($log) {

    $log.info('semy.vendor running.');

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy.stripe', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.stripe')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('stripe', {
        url:'/stripe',
        templateUrl:'app/stripe/stripe.html',
        controller:'StripeController',
        controllerAs:'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('semy.stripe')
    .controller('StripeController', StripeController);

  StripeController.$inject = ['$log', 'Auth', 'Vendors', 'Toast'];

  function StripeController($log, Auth, Vendors, Toast) {

    var vm = this;
    vm.success = true;

    Auth.$requireSignIn();

    var url = new URL(window.location.href);
    var code = url.searchParams.get("code");
    var vendorKey = url.searchParams.get("state");
    if (!code || !vendorKey || vendorKey.match(/[^0-9a-zA-Z_\-]/)) {
      error("Invalid input");
    } else {
      Vendors.stripeOauth({objectKey: vendorKey, stripeToken: code}, {},
        function () {
          window.location.href = "/vendor/" + vendorKey + "/settings";
        }, function (error) {
          error(error);
          vm.success = false;
        });

    }
    activate();

    function error(error) {
      $log.error(angular.toJson(error));
      Toast.error(error);
    }


    function activate() {
      $log.info('Activate StripeController');
    }

  }

})();

(function () {

  'use strict';

  /**
   * @ngdoc overview
   * @name semy
   * @description
   * semy angular app...
   *
   */
  angular
    .module('semy', [
      'ngAnimate',
      'ngCookies',
      'ngResource',
      'ngSanitize',
      'ngTouch',
      'ngRoute',
      'ngMaterial',
      'ui.router',
      'firebase',
      'infinite-scroll',
      'gridshore.c3js.chart',
      'ui.sortable',
      'semy.auth',
      'semy.stripe',
      'semy.admin',
      'semy.admin.main',
      'semy.admin.dashboard',
      'semy.admin.vendors',
      'semy.admin.users',
      'semy.admin.settings',
      'semy.vendor.vendor-selector',
      'semy.admin.global',
      'semy.admin.item-templates',
      'semy.vendor',
      'semy.vendor.main',
      'semy.vendor.dashboard',
      'semy.vendor.settings',
      'semy.vendor.detail',
      'semy.vendor.menu',
      'semy.vendor.orders',
      'semy.vendor.users',
      'semy.vendor.invitations'
    ]);

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('semy')
    .factory('Toast', Toast);

  Toast.$inject = ['$mdToast'];

  function Toast($mdToast) {


    function success(message) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
      );
    }

    function error(error) {

      var message = 'Something went wrong!';
      if (angular.isString(error)) {
        message = error;
      }
      else if (angular.isObject(error)){
        message = error.message || error.data.message || error.data.error.message  || message;
      }

      $mdToast.show(
        $mdToast.simple()
          .toastClass('error-toast')
          .textContent(message)
      );

    }

    return {
      success : success,
      error : error
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('semy')
    .factory('Geo', Geo);

  Geo.$inject = ['$resource'];

  function Geo($resource) {

    var url = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyB8LNUFf0ErV_YPTUq8NGsoE9JX0HbVkc4';

    return $resource(url, null,
      {
        code: { method: 'GET' }
      });
  }

})();

(function () {
  'use strict';

  angular.module('semy')
    .directive('fileUploader', fileUploader);

  fileUploader.$inject = [];

  function fileUploader() {
    return {
      template: '<input type="file"/>',
      scope: {
        onUpload: "&?",
        path: "@",
        filenamer: "&?"
      },
      require: '?ngModel',
      link: function (scope, element, attrs, ngModel) {
        var uploadHandler = scope.onUpload;
        element.on('change', function(event) {
          var filename = event.target.files[0].name;
          if (scope.filenamer) {
            filename = scope.filenamer({filename: event.target.files[0].name});
          }
          var storageRef = firebase.storage().ref();
          if (!scope.path) {
            throw Error("path must be set on file-uploader");
          }
          var fileRef = storageRef.child(scope.path + "/" + firebase.auth().currentUser.uid + "/" + new Date().getTime() + "." + filename);
          var task = fileRef.put(event.target.files[0]);
          task.on(firebase.storage.TaskEvent.STATE_CHANGED,
            function (snapshot) {

            }, function (error) {

            }, function() {
              fileRef.getDownloadURL().then(function (fileUrl) {
                if (uploadHandler) {
                  uploadHandler({fileUrl: fileUrl});
                }
                if (ngModel) {
                  ngModel.$setViewValue(fileUrl);
                }
                event.target.value = null;
              });
            }
          );
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('semy')
    .directive('semyBack', semyBack);

  semyBack.$inject = ['$window'];

  function semyBack($window) {
    return {
      restrict: 'A',
      link: function (scope, elem) {
        elem.bind('click', function () {
          $window.history.back();
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth', []);

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .factory('targetService', targetService);

  targetService.$inject = [];

  function targetService() {

    var instance = {
      target: undefined
    };

    instance.reset = function() {
      instance.target = undefined;
    };

    return instance;

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['$scope', '$log', '$state', 'Auth', 'Accounts', 'targetService'];

  function LoginController($scope, $log, $state, Auth, Accounts, targetService) {

    var vm = this;

    vm.user = {};
    vm.error = '';
    vm.login = login;
    vm.loading = false;

    function login(form, user) {

      if (!form.$valid) {return;}

      vm.error = '';
      vm.loading = true;
      $scope.$emit('loading', true);

      Auth.$signInWithEmailAndPassword(user.email, user.password)
        .then( ensureAccountExists )
        .then( finish )
        .catch( showError );

      function finish(account) {

        $log.info("Account");
        $log.info(angular.toJson(account));

        if (angular.isDefined(targetService.targetState) &&
          angular.isDefined(targetService.targetState.name)) {

          $state.go(targetService.targetState.name, targetService.targetParams);
          targetService.reset();

        }
        else {
          $state.go('auth.app');
        }
      }
    }

    function showError(error) {

      vm.loading = false;
      $scope.$emit('loading', false);
      vm.error = error.message || error.data.message || error;
      $log.error('Authentication failed:', error);

    }

    function ensureAccountExists() {
      return Accounts.me().$promise;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .controller('ForgotController', ForgotController);

  ForgotController.$inject = ['$scope', '$log', 'Auth'];

  function ForgotController($scope, $log, Auth) {

    var vm = this;

    vm.resetPassword = resetPassword;

    function resetPassword(form, email) {

      if (!form.$valid || angular.isUndefined(email)) {return;}

      vm.loading = true;
      $scope.$emit('loading', true);

      Auth.$sendPasswordResetEmail(email).then(function() {

        $scope.$emit('loading', false);
        $log.info('Password reset email sent');
        vm.message = 'Sent! Check your email.';

      }).catch(function(error) {
        $log.error('Error: ', error);
        vm.error = error.message;
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .factory('Auth', Auth);

  Auth.$inject = ['$firebaseAuth'];

  function Auth($firebaseAuth) {
    return $firebaseAuth();
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('auth', {
        url:'',
        templateUrl:'app/auth/auth.html',
        controller:'AuthController',
        controllerAs:'vm'
      })
      .state('auth.app', {
        url:'/app',
        template:'',
        controller:'AppController',
        controllerAs:'vm'})
      .state('auth.login', {
        url:'/login',
        templateUrl:'app/auth/login.html',
        controller:'LoginController',
        controllerAs:'vm'})
      .state('auth.claim', {
        url:'/claim?email&invitation&existing&vendorName',
        templateUrl:'app/auth/auth.claim.html',
        controller:'AuthClaimController',
        controllerAs:'vm'})
      .state('auth.forgot', {
        url:'/forgot',
        templateUrl:'app/auth/forgot.html',
        controller:'ForgotController',
        controllerAs:'vm'})
      .state('auth.action', {
        url: '/auth/action?mode&oobCode',
        templateUrl: 'app/auth/auth.action.html',
        controller: 'AuthActionController',
        controllerAs: 'vm'
      });

  }

})();



'use strict';

(function () {

  angular
    .module('semy')
    .factory('AuthResolver', AuthResolver);

  AuthResolver.$inject = ['Auth', 'Accounts', '$q'];

  function AuthResolver(Auth, Accounts, $q) {

    return function () {

      function onAuth() {
        return Accounts.me().$promise;
      }

      function onError() {
        return $q.reject('AUTH_REQUIRED');
      }

      /// rejects with AUTH_REQUIRED
      return Auth.$requireSignIn()
        .then(onAuth)
        .catch(onError);

    };
  }

})();

(function () {

  'use strict';

  angular
    .module('semy')
    .factory('FirebaseTokenInterceptor', FirebaseTokenInterceptor);

  FirebaseTokenInterceptor.$inject = ['Auth', '$q', '$log'];

  function FirebaseTokenInterceptor(Auth, $q, $log) {

    return {

      request: function(config) {

        if (config.url.indexOf('api/admin') === -1) {
          return config;
        }

        var deferred = $q.defer();

        function onAuth(currentAuth) {
          return currentAuth.getToken(false)
            .then(onToken, onError);
        }

        function onToken(token) {
          $log.info(token);
          config.headers.Authorization = 'Bearer ' + token;
          deferred.resolve(config);
        }

        function onError() {
          return deferred.resolve(config);
        }

        Auth.$requireSignIn().then(onAuth, onError);

        return deferred.promise;

      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .controller('AuthController', AuthController);

  AuthController.$inject = ['$scope'];

  function AuthController($scope) {

    var vm = this;

    vm.loading = false;

    $scope.$on('loading', function(event, isLoading) {
      vm.loading = isLoading;
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .controller('AuthClaimController', AuthClaimController);

  AuthClaimController.$inject = ['Auth', 'Accounts', 'Toast', '$state', '$stateParams', '$scope', '$log', '$http'];

  function AuthClaimController(Auth, Accounts, Toast, $state, $stateParams, $scope, $log, $http) {

    var vm = this;

    vm.user = {};
    vm.error = '';
    vm.loading = false;
    vm.emailDisabled = false;
    vm.vendorName = $stateParams.vendorName;

    vm.invitation = $stateParams.invitation;

    if (angular.isDefined($stateParams.email) && $stateParams.existing === "true") {
      vm.user.existingEmail = $stateParams.email;
      vm.user.email = $stateParams.email;
      vm.emailDisabled = true;
    }

    vm.register = register;

    function addVendor(user, invitationKey) {
      Auth.$signInWithEmailAndPassword(user.email, user.password)
        .then(function(currentAuth) {
          return currentAuth.getToken(false);
        })
        .then(function(token) {
          $http.defaults.headers.common.Authorization = 'Bearer ' + token;
          return Accounts.me().$promise;
        })
        .then(function(me) {
          return Accounts.addVendor({objectKey: me.key, inviteKey: invitationKey}, {}).$promise;
        })
        .catch(function(error) {
          var account = {
            invitation: vm.invitation,
            name:user.name,
          };
          return Accounts.signup(account).$promise;
        })
        .then(function() {
          $scope.$emit('loading', false);
          $state.go('auth.app');
        })
        .catch(handleError);
    }

    function register(form, user) {

      if (!form.$valid) {
        // vm.error = form.$error;
        return;
      }

      if (angular.isUndefined(vm.invitation)) {
        return;
      }

      vm.loading = true;
      $scope.$emit('loading', true);

      var account = {
        invitation: vm.invitation,
        name:user.name,
      };

      if (vm.user.existingEmail) {
        addVendor(user, vm.invitation);
      } else {
        Auth.$createUserWithEmailAndPassword(user.email, user.password)
          .then(function (currentAuth) {
            return currentAuth.getToken(false);
          })
          .then(function (token) {
            $http.defaults.headers.common.Authorization = 'Bearer ' + token;
            return Accounts.signup(account).$promise;
          })
          .then(function () {
            $scope.$emit('loading', false);
            $state.go('auth.app');
          })
          .catch(function (error) {
            if (error.code === "auth/email-already-in-use") {
              addVendor(user, vm.invitation);
            } else {
              handleError(error);
            }
          });
      }

    }

    function handleError(error) {
      vm.loading = false;
      $scope.$emit('loading', false);
      $log.error('Error: ', angular.toJson(error));
      Toast.error(error);
      vm.error = error.message;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('semy.auth')
    .controller('AppController', AppController);

  AppController.$inject = ['Accounts', 'Toast', '$state', '$log'];

  function AppController(Accounts, Toast, $state, $log) {

    Accounts.me(null, success, error);

    function success(account) {
      if (angular.isObject(account.vendor) && angular.isString(account.vendor.key)) {
        $state.go('vendor.dashboard', { objectKey: account.vendor.key });
      } else {
        $state.go('admin.dashboard');
      }
    }

    function error(response) {
      $log.info(angular.toJson(response));
      $state.go('auth.login');
    }



  }

})();

(function() {
  'use strict';

  /* global firebase */

  angular
    .module('semy.auth')
    .controller('AuthActionController', AuthActionController);

  AuthActionController.$inject = ['$scope', '$stateParams', '$state', '$q', '$log', 'Auth'];

  function AuthActionController($scope, $stateParams, $state, $q, $log, Auth) {

    var vm = this;

    var __auth = firebase.auth();

    vm.mode = $stateParams.mode;
    var oobCode = $stateParams.oobCode;

    if (angular.isUndefined(vm.mode) || angular.isUndefined(oobCode)) {
      $state.go('auth.login');
      return;
    }

    vm.password = '';
    vm.error = '';
    vm.verify = verify;
    vm.resetPassword = resetPassword;

    activate();

    function activate() {

      if (vm.mode === 'verifyEmail') {

        $scope.$emit('loading', true);
        $q.when(__auth.applyActionCode(oobCode)).then(function() {
          $state.go('auth.app');
        }).catch(showError);

      } else if (vm.mode === 'resetPassword') {

        $scope.$emit('loading', true);
        $q.when(__auth.verifyPasswordResetCode(oobCode)).then(function(email) {
          $scope.$emit('loading', false);
          vm.email = email;
        }).catch(showError);

      }
    }

    function showError(error) {
      $scope.$emit('loading', false);
      $log.error(error.message);
      vm.error = error.message;
    }

    function verify() {
      var firebaseUser = Auth.$getAuth();
      if (firebaseUser === null) {
        $state.go('auth.login');
        return;
      }
      firebaseUser.sendEmailVerification().then(function() {
        vm.message = 'Sent! Check your email.';
      });
    }

    function resetPassword() {

      if (angular.isUndefined(vm.email) || angular.isUndefined(vm.password)) {
        return;
      }

      $scope.$emit('loading', true);

      $q.when(__auth.confirmPasswordReset(oobCode, vm.password)).then(function() {
        Auth.$signInWithEmailAndPassword(vm.email, vm.password).then(function() {
          $state.go('auth.app');
          $scope.$emit('loading', false);
        }).catch(showError);
      }).catch(showError);

    }

  }

})();

(function () {

  'use strict';

  angular
    .module('semy.auth')
    .factory('Accounts', Accounts);

  Accounts.$inject = ['$resource', 'apiUrl'];

  function Accounts($resource, apiUrl) {

    var root = apiUrl + '/accounts/';
    var url = root + ':objectKey';
    var me = root + 'me';
    var signup = root + 'signup';
    var search = root + 'search';
    var updateEmail = url + '/email';
    var addVendorUrl = url + "/vendors/:inviteKey/add";

    return $resource(url, null,
      {
        me: { url: me, method: 'GET' },
        get: { method: 'GET' },
        updateEmail: { method: 'PUT', url: updateEmail },
        remove: { method: 'DELETE'},
        signup: { method: 'POST', url: signup },
        insert: { method: 'POST' },
        update: { method: 'PUT' },
        list: { method: 'GET' },
        addVendor: { method: 'POST', url: addVendorUrl},
        search: { method: 'GET', url:search }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('semy.admin')
    .run(Run);

  Run.$inject = ['$log'];

  function Run($log) {

    $log.info('semy.admin running.');

  }

})();

(function() {
  'use strict';

  angular
    .module('semy')
    // .constant('apiUrl', 'https://semy-development.appspot.com/_ah/api/admin/v1');
    // .constant('apiUrl', 'https://semy-staging.appspot.com/_ah/api/admin/v1');
    // .constant('apiUrl', 'https://20190725t225602-dot-semy-production.appspot.com/_ah/api/admin/v1');
    .constant('apiUrl', 'https://semy-production.appspot.com/_ah/api/admin/v1');
    // .constant('apiUrl', 'http://localhost:8080/_ah/api/admin/v1');

})();

(function () {
  'use strict';

  /* global firebase */

  angular
    .module('semy')
    .config(config);

  config.$inject = ['$httpProvider', '$locationProvider', '$mdThemingProvider', '$urlRouterProvider'];

  function config($httpProvider, $locationProvider, $mdThemingProvider, $urlRouterProvider) {

    $mdThemingProvider.definePalette('semyPalette', {
      '50': 'e6f4f3',
      '100': 'bfe4e0',
      '200': '95d3cc',
      '300': '6bc1b7',
      '400': '4bb3a7',
      '500': '2ba698',
      '600': '269e90',
      '700': '209585',
      '800': '1a8b7b',
      '900': '107b6a',
      'A100': 'aefff1',
      'A200': '7bffe8',
      'A400': '48ffde',
      'A700': '2fffda',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.theme('default')
      .primaryPalette('semyPalette');

    /// semy-development
    // Initialize Firebase
    var developmentConfig = {
      apiKey: 'AIzaSyBgghz7b9sgOJ_pNaE6JAjFlhInTVmkp54',
      authDomain: 'semy-development.firebaseapp.com',
      databaseURL: 'https://semy-development.firebaseio.com',
      projectId: 'semy-development',
      storageBucket: 'semy-development.appspot.com',
      messagingSenderId: '643195249258',
      stripeAuthURL: 'https://connect.stripe.com/express/oauth/authorize?client_id=ca_BEeZoUAOU8vBXTuNqz6v49zpCDtGGgcM'
    };

    // semy-staging
    var stagingConfig = {
      apiKey: "AIzaSyDNhODfF2L2vx_vEktB9tvykTcytipLAAA",
      authDomain: "semy-staging.firebaseapp.com",
      databaseURL: "https://semy-staging.firebaseio.com",
      projectId: "semy-staging",
      storageBucket: "semy-staging.appspot.com",
      messagingSenderId: "407198667976",
      stripeAuthURL: 'https://connect.stripe.com/express/oauth/authorize?client_id=ca_BEeZoUAOU8vBXTuNqz6v49zpCDtGGgcM'
    };


    /// semy-production
    var productionConfig = {
      apiKey: 'AIzaSyBVpTy2DE6M052FGiuEvaM6K3avZ8eIKtY',
      authDomain: 'semy-production.firebaseapp.com',
      databaseURL: 'https://semy-production.firebaseio.com',
      projectId: 'semy-production',
      storageBucket: 'semy-production.appspot.com',
      messagingSenderId: '299716704639',
      stripeAuthURL: 'https://connect.stripe.com/express/oauth/authorize?client_id=ca_BEeZ3ISiipw8KNe3kAPv4D0J9pHCV71Q'
    };

    var config = {
      "semy-development": developmentConfig,
      "semy-staging": stagingConfig,
      "semy-production": productionConfig
    };

    firebase.initializeApp(config["semy-production"]);
    // firebase.initializeApp(config["semy-staging"]);

    $locationProvider.html5Mode(true);

    $httpProvider.interceptors.push('FirebaseTokenInterceptor');
    $urlRouterProvider.otherwise('/app');

  }

})();

angular.module("semy").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.action.html","<div ng-switch=\"vm.mode\"><div ng-switch-when=\"resetPassword\"><h3>Reset Password</h3><span class=\"help-block m-b-none\">{{vm.email}}</span><form name=\"form\"><md-input-container class=\"md-block\" style=\"margin-top: 35px;\"><label>Password</label> <input type=\"password\" ng-model=\"vm.password\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-button type=\"submit\" ng-click=\"vm.resetPassword()\" class=\"md-raised md-primary\" ng-disabled=\"vm.loading\">Login</md-button></form></div><div ng-switch-when=\"needsVerification\"><h3>Verify Email Address</h3><a class=\"btn btn-sm btn-white btn-block\" ng-click=\"vm.verify()\">Resend Verification Email</a></div><div ng-switch-when=\"verifyEmail\"><h3>Verifying Email Address</h3></div></div><span class=\"help-block m-b-none error-block\">{{vm.error}}</span>");
$templateCache.put("app/auth/auth.claim.html","<form name=\"form\"><h3>Claim Account<span ng-show=\"vm.vendorName\">&nbsp;for {{vm.vendorName}}</span></h3><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-disabled=\"vm.emailDisabled || vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Password</label> <input type=\"password\" ng-model=\"vm.user.password\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container ng-hide=\"vm.user.existingEmail\" class=\"md-block\"><label>Name</label> <input ng-model=\"vm.user.name\" ng-required=\"!vm.user.email\" ng-disabled=\"vm.loading\"></md-input-container><p style=\"color:red;\">{{vm.error}}</p><md-button type=\"submit\" ng-click=\"vm.register(form, vm.user)\" class=\"md-raised md-primary\" ng-disabled=\"vm.loading\">Login</md-button></form>");
$templateCache.put("app/auth/auth.html","<div layout=\"row\" layout-fill=\"layout-fill\" layout-align=\"center center\"><div layout=\"row\" layout-padding=\"\" flex=\"50\"><div layout=\"column\" flex=\"\" layout-align=\"center center\"><img style=\"border-radius: 10px;\" src=\"../../assets/icon.png\"><div style=\"margin-top:15px;\">Semyapp &copy; 2020</div></div><div layout=\"column\" ui-view=\"\" style=\"margin-left:15px; width:350px;\"></div></div></div>");
$templateCache.put("app/auth/forgot.html","<form name=\"form\"><h3>Forgot password</h3><p>Enter your email address and we will send you a link to reset you password.</p><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.email\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"md-warn\">{{ vm.error }}</span></md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"vm.resetPassword(form, vm.email)\" ng-disabled=\"vm.loading\">Reset Password</md-button><span class=\"primary\">{{ vm.message }}</span></form>");
$templateCache.put("app/auth/login.html","<form name=\"form\"><h3>Sign in</h3><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Password</label> <input type=\"password\" ng-model=\"vm.user.password\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"error md-caption\">{{vm.error}}</span></md-input-container><div layout=\"row\"><md-button style=\"text-transform: capitalize;\" md-no-ink=\"md-no-ink\" ui-sref=\"auth.forgot\">Forgot password?</md-button><div flex=\"\"></div><md-button class=\"md-raised md-primary\" type=\"submit\" ng-click=\"vm.login(form, vm.user)\" ng-disabled=\"vm.loading\">Login</md-button></div></form>");
$templateCache.put("app/stripe/stripe.html","Connecting stripe...<div ng-show=\"!vm.success\">Failed to connect<div><a href=\"/dashboard\">Go to dashboard</a></div></div>");
$templateCache.put("app/admin/dashboard/admin.dashboard.html","<div layout=\"column\" layout-padding=\"\" flex=\"\"><h1>Dashboard</h1><md-content layout-padding=\"\" flex=\"\"><md-grid-list md-cols-gt-md=\"12\" md-cols=\"3\" md-cols-md=\"8\" md-row-height-gt-md=\"1:1\" md-row-height=\"4:3\" md-gutter-gt-md=\"16px\" md-gutter-md=\"8px\" md-gutter=\"4px\"><md-grid-tile ng-repeat=\"tile in vm.colorTiles\" ng-style=\"{ \'background\': tile.color }\" md-colspan-gt-sm=\"{{tile.colspan}}\" md-rowspan-gt-sm=\"{{tile.rowspan}}\"></md-grid-tile></md-grid-list></md-content></div>");
$templateCache.put("app/admin/global/admin.global.settings.html","<div layout=\"column\" layout-padding=\"\"><div layout=\"row\" layout-align=\"center center\"><h1>Global Settings</h1><div flex=\"\"></div><md-progress-circular ng-show=\"vm.loading\" ng-disabled=\"!vm.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button flex=\"none\" ng-click=\"vm.save(form)\" class=\"md-primary md-raised\">Save Changes</md-button></div><form name=\"form\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Fixed Fee (in USD cents)</label> <input required=\"\" name=\"fixedFee\" ng-model=\"vm.config.fixedPriceFee\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Percentage Fee (EG 0.0688 for 6.88%)</label> <input required=\"\" name=\"percentagePriceFee\" ng-model=\"vm.config.percentagePriceFee\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Tip Percentage (EG 0.10 for 10%)</label> <input required=\"\" name=\"tipPercentage\" ng-model=\"vm.config.tipPercentage\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Stripe Plan ID</label> <input required=\"\" name=\"stripePlanId\" ng-model=\"vm.config.stripePlanId\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div><h3>Agreement Uplaod</h3><div ng-show=\"vm.config.agreementUrl\"><md-button class=\"md-raised\" href=\"{{vm.config.agreementUrl}}\" target=\"_blank\">View Agreement</md-button></div><md-divider></md-divider><file-uploader path=\"vendor-doc\" ng-model=\"vm.config.agreementUrl\"></file-uploader></div><div class=\"md-warn\">{{ vm.error }}</div></form></div>");
$templateCache.put("app/admin/item-templates/admin.item-templates.edit.html","<md-chip layout=\"column\" layout-padding=\"\"><div layout=\"row\" layout-align=\"center center\"><h1>{{ vm.itemTemplate.name || \'New Item Template\'}}</h1><div flex=\"\"></div><md-progress-circular ng-show=\"vm.loading\" ng-disabled=\"!vm.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button ng-hide=\"vm.itemTemplate.key\" flex=\"none\" ng-click=\"vm.save(form)\" class=\"md-primary md-raised\">Create</md-button><md-button ng-show=\"vm.itemTemplate.key\" flex=\"none\" ng-click=\"vm.save(form)\" class=\"md-primary md-raised\">Save Changes</md-button></div><form name=\"form\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Name</label> <input required=\"\" name=\"name\" ng-model=\"vm.itemTemplate.name\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Image URL</label> <input required=\"\" name=\"imageUrl\" ng-model=\"vm.itemTemplate.imageUrl\" flex=\"\"><div ng-messages=\"form.imageUrl.$error\"><div ng-message=\"required\">This is required.</div></div><img style=\"max-height: 200px;\" src=\"{{vm.itemTemplate.imageUrl}}\"></md-input-container><div layout=\"row\"><md-input-container flex=\"100\"><label>Description</label> <textarea name=\"description\" ng-model=\"vm.itemTemplate.description\" md-maxlength=\"400\" md-select-on-focus=\"\"></textarea><div ng-messages=\"form.description.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label>Price</label> <input required=\"\" name=\"price\" ng-model=\"vm.itemTemplate.price\"><div ng-messages=\"form.price.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><h4>Categories</h4><md-chips ng-model=\"vm.itemTemplate.categories\" md-enable-chip-edit=\"true\" placeholder=\"Add a category\"></md-chips><h4>Values</h4><md-chips name=\"values\"><md-chip style=\"height: 60px; padding-top: 10px;\" ng-repeat=\"(key,value) in vm.itemTemplate.values\"><md-input-container><label>{{key}}</label> <input name=\"{{key}}_value\" required=\"\" type=\"text\" ng-model=\"vm.itemTemplate.values[key]\"><div ng-messages=\"form.{key}_value.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><span style=\"float:right;cursor: pointer;\" ng-click=\"vm.removeValue(key)\">X</span></md-chip></md-chips><md-button style=\"margin-top: 20px; height: 20px;\" class=\"md-raised\" ng-click=\"vm.newValue()\">Add Value</md-button></form><div class=\"md-warn\">{{ vm.error }}</div></md-chip>");
$templateCache.put("app/admin/item-templates/admin.item-templates.html","<md-button class=\"md-primary md-raised\" ui-sref=\"admin.itemTemplatesEdit({objectKey:null})\">New</md-button><md-input-container style=\"margin-left:24px; margin-right: 24px;\" flex=\"\" class=\"md-block\"><label>Search</label> <input name=\"search\" ng-model=\"vm.search\" ng-change=\"vm.searchItemTemplates()\"></md-input-container><div layout=\"column\" layout-padding=\"\" infinite-scroll=\"vm.loadMore()\" infinite-scroll-parent=\"\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"itemTemplate in vm.itemTemplates\"><img ng-src=\"{{itemTemplate.imageUrl}}\" class=\"md-avatar\" alt=\"{{itemTemplate.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ itemTemplate.name }}</h3><p>{{ itemTemplate.categories.join(\", \") }}</p></div><md-button ui-sref=\"admin.itemTemplatesEdit({objectKey:itemTemplate.key})\">Edit</md-button></md-list-item></md-list><div layout=\"row\" layout-align=\"center\" ng-show=\"vm.loadingMore\"><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/admin/main/admin.main.html","<div layout=\"row\" layout-fill=\"layout-fill\"><md-sidenav class=\"md-sidenav-left\" md-component-id=\"left\" md-is-locked-open=\"true\" md-whiteframe=\"4\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h1 class=\"md-toolbar-tools\">Semy Admin</h1><div flex=\"\"></div><img style=\"height:100%;\" src=\"../../../assets/icon.png\"></div></md-toolbar><md-content><md-list><md-list-item ng-repeat=\"item in vm.menu\"><div ui-sref=\"{{item.sref}}\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">{{item.icon}}</i></div><div class=\"inset\">{{item.title}}</div></div></md-list-item><md-divider></md-divider><md-subheader>Settings</md-subheader><md-list-item ng-repeat=\"item in vm.settings\"><div ui-sref=\"{{item.sref}}\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">{{item.icon}}</i></div><div class=\"inset\">{{item.title}}</div></div></md-list-item></md-list></md-content></md-sidenav><md-content ui-view=\"\" flex=\"\"></md-content></div>");
$templateCache.put("app/admin/settings/admin.settings.html","<div layout=\"column\" layout-padding=\"\"><h1>Account Settings</h1><p>Last Updated: {{ vm.account.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p><form name=\"form\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Account Type</label> <input disabled=\"true\" name=\"accountType\" ng-model=\"vm.account.accountType\" flex=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Name</label> <input required=\"\" name=\"name\" ng-model=\"vm.account.name\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">Name is required.</div></div></md-input-container><md-input-container><md-button ng-disabled=\"!form.$valid\" class=\"md-primary md-raised\" ng-click=\"vm.save(form, vm.account)\">Save Changes</md-button></md-input-container></form><h1>Email Settings</h1><form name=\"emailForm\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Email</label> <input required=\"\" type=\"email\" name=\"email\" ng-model=\"vm.account.email\" flex=\"\"><div ng-messages=\"emailForm.email.$error\"><div ng-message=\"required\">Email is required.</div></div></md-input-container><md-input-container><md-button ng-disabled=\"!emailForm.$valid\" class=\"md-primary md-raised\" ng-click=\"vm.updateEmail(emailForm, vm.account)\">Change Email</md-button></md-input-container></form><div class=\"vendor-detail\"><h1>Other</h1><md-button class=\"md-warn md-raised\" ng-click=\"vm.logout()\">Logout</md-button><md-button class=\"\" ng-click=\"vm.grabToken()\">Grab Token (Development Only)</md-button></div><pre>{{ vm.token }}</pre><div style=\"height:100px;\"></div></div>");
$templateCache.put("app/admin/users/admin.users.html","<div layout=\"column\" layout-padding=\"\" infinite-scroll=\"vm.loadMoreUsers()\" infinite-scroll-parent=\"\"><div layout=\"row\"><h1 class=\"md-block\">Users</h1><md-input-container style=\"margin-left:24px; margin-right: 24px; min-width: 100px;\"><label>Filter</label><md-select ng-model=\"vm.params.type\" ng-change=\"vm.loadUsers()\" class=\"md-block\"><md-option value=\"User\">Users</md-option><md-option value=\"Suspended\">Suspended</md-option></md-select></md-input-container><md-input-container style=\"margin-left:24px; margin-right: 24px;\" flex=\"\" class=\"md-block\"><label>Search</label> <input name=\"search\" ng-model=\"vm.params.search\" ng-change=\"vm.loadUsers()\"></md-input-container></div><md-list class=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"user in vm.users\"><img ng-src=\"{{ user.imageUrl || \'../../../assets/person.png\' }}\" class=\"md-avatar\" alt=\"Image\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ user.name }}</h3><p>{{ user.accountType }}</p></div><md-button ng-show=\"user.accountType === \'User\'\" class=\"md-warn\" ng-click=\"vm.block(user)\">Suspend</md-button><md-button ng-show=\"user.accountType === \'Suspended\'\" class=\'md-primary\"\' ng-click=\"vm.unblock(user)\">Reactivate</md-button></md-list-item></md-list><div layout=\"row\" layout-align=\"center\" ng-show=\"vm.loadingMore\"><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/admin/vendors/admin.vendor.settings.html","<div layout=\"column\" layout-padding=\"\"><div layout=\"row\" layout-align=\"center center\"><h1>{{ vm.settings.vendorName }}</h1><div flex=\"\"></div><md-progress-circular ng-show=\"vm.loading\" ng-disabled=\"!vm.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button flex=\"none\" ng-click=\"vm.save(form)\" class=\"md-primary md-raised\">Save Changes</md-button></div><form name=\"form\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Fixed Fee Discount Percentage (EG. 0.25 for 25%)</label> <input name=\"name\" ng-model=\"vm.settings.feeDiscountPercentage\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></form><div><h3>Vendor Document</h3><div ng-hide=\"!vm.settings.documentUrl\"><a href=\"{{vm.settings.documentUrl}}\" target=\"_blank\">Document Link</a><hr></div><file-uploader filenamer=\"vm.generateDocFilename(filename)\" path=\"vendor-doc\" on-upload=\"vm.documentUpload(fileUrl)\"></file-uploader></div><div class=\"md-warn\">{{ vm.error }}</div></div>");
$templateCache.put("app/admin/vendors/admin.vendors.html","<div layout=\"column\" layout-padding=\"\" infinite-scroll=\"vm.loadMoreVendors()\" infinite-scroll-parent=\"\"><div layout=\"row\"><h1 class=\"md-block\">Vendors</h1><md-input-container style=\"margin-left:24px; margin-right: 24px; min-width: 100px;\"><label>Filter</label><md-select ng-model=\"vm.params.active\" ng-change=\"vm.loadVendors()\" class=\"md-block\"><md-option value=\"true\">Active</md-option><md-option value=\"false\">Inactive</md-option></md-select></md-input-container><md-input-container style=\"margin-left:24px; margin-right: 24px;\" flex=\"\" class=\"md-block\"><label>Search</label> <input name=\"search\" ng-model=\"vm.params.search\" ng-change=\"vm.loadVendors()\"></md-input-container><div layout=\"column\" layout-align=\"\"><md-button class=\"md-primary md-raised md-block md-button\" ui-sref=\"admin.vendorDetail({objectKey:\'new\'})\">Add Vendor</md-button></div></div><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"vendor in vm.vendors\"><img ng-src=\"{{vendor.imageUrl}}\" class=\"md-avatar\" alt=\"{{vendor.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ vendor.name }}</h3><p class=\"error\">{{ vendor.active ? \'\' : \'Inactive\' }}</p><p>{{ vendor.location.street }} {{ vendor.location.city }} {{ vendor.location.state }} {{ vendor.location.postalCode }}</p></div><md-button ui-sref=\"vendor.dashboard({objectKey:vendor.key})\">Manage</md-button><md-button ui-sref=\"admin.vendorDetail({objectKey:vendor.key})\">Edit Info</md-button><md-button ui-sref=\"admin.vendorMenu({objectKey: vendor.key})\">Edit Menu</md-button><md-button ng-show=\"vm.account.accountType === \'Admin\'\" ui-sref=\"admin.vendorSettings({objectKey:vendor.key})\">Edit Admin Settings</md-button></md-list-item></md-list><div layout=\"row\" layout-align=\"center\" ng-show=\"vm.loadingMore\"><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/vendor/dashboard/vendor.dashboard.html","<div layout=\"column\" layout-padding=\"\" flex=\"\"><div layout=\"row\" layout-align=\"left center\"><img style=\"height:100px;\" ng-src=\"{{ vm.vendor.imageUrl }}\"><h1 style=\"margin-left:24px; margin-top:0; margin-bottom:0;\">{{ vm.vendor.name }}<br>Dashboard</h1></div><md-content><h3>Today</h3><md-grid-list md-cols=\"6\" md-row-height=\"1:1\" md-gutter=\"8px\"><md-grid-tile md-colspan=\"2\" md-rowspan=\"2\" style=\"background: #00E676;\"><div layout=\"column\" class=\"stat\"><div class=\"big-num\">14 <span class=\"delta\">+20%</span></div><h1>Orders<br>Redeemed</h1></div></md-grid-tile><md-grid-tile md-colspan=\"2\" md-rowspan=\"2\" style=\"background: #80DEEA;\"><div layout=\"column\" class=\"stat\"><div class=\"big-num\">8 <span class=\"delta\">+10.6%</span></div><h1>New<br>Customers</h1></div></md-grid-tile><md-grid-tile md-colspan=\"2\" md-rowspan=\"2\" style=\"background: #8D6E63;\"><div layout=\"column\" class=\"stat\"><div class=\"big-num\">$312 <span class=\"delta\">+5%</span></div><h1>Sales<br>&nbsp;</h1></div></md-grid-tile></md-grid-list><h3>Breakdown</h3><md-grid-list md-cols=\"6\" md-row-height=\"1:1\" md-gutter=\"8px\"><md-grid-tile md-colspan=\"3\" md-rowspan=\"2\" style=\"background: #ECEFF1;\"><div id=\"pie-plot1-chart\" style=\"width:100%; height:95%;\"><c3chart bindto-id=\"pie-plot1-chart\" sort-data=\"desc\"><chart-column column-id=\"On Tap\" column-values=\"70\" column-type=\"pie\"><chart-column column-id=\"Cocktails\" column-values=\"35\" column-type=\"pie\"><chart-column column-id=\"Cans\" column-values=\"60\" column-type=\"pie\"><chart-column column-id=\"Bottles\" column-values=\"60\" column-type=\"pie\"><chart-column column-id=\"Cider\" column-values=\"60\" column-type=\"pie\"><chart-pie title=\"Categories\" expand=\"true\" show-label=\"true\" threshold-label=\"0.1\"></chart-pie></chart-column></chart-column></chart-column></chart-column></chart-column></c3chart></div></md-grid-tile><md-grid-tile md-colspan=\"3\" md-rowspan=\"2\" style=\"background: #ECEFF1;\"><div id=\"donut-plot1-chart\" style=\"height:95%; width:95%;\"><c3chart bindto-id=\"donut-plot1-chart\"><chart-column column-id=\"Revolution Anti-Hero IPA\" column-values=\"31\" column-type=\"donut\"><chart-column column-id=\"Bell\'s Oberon\" column-values=\"35\" column-type=\"donut\"><chart-column column-id=\"Blue Moon Belgian Style Wheat\" column-values=\"60\" column-type=\"donut\"><chart-column column-id=\"Other\" column-values=\"20\" column-type=\"donut\"><chart-donut title=\"Beers\" width=\"50\" show-label=\"true\" label-format-function=\"formatDonut\" threshold-label=\"0.1\"></chart-donut></chart-column></chart-column></chart-column></chart-column></c3chart></div></md-grid-tile></md-grid-list><h3>Sales</h3><md-grid-list md-cols=\"6\" md-row-height=\"1:1\" md-gutter=\"8px\"><md-grid-tile md-colspan=\"6\" md-rowspan=\"2\" style=\"background: #ECEFF1;\"><div id=\"chart1\" style=\"width:90%; height:90%;\"><c3chart bindto-id=\"chart1\" chart-data=\"vm.datapoints\" chart-columns=\"vm.datacolumns\" chart-x=\"vm.datax\"><chart-bar ratio=\"0.5\"><chart-axes values-x=\"x\"><chart-axis><chart-axis-x axis-position=\"outer-center\" axis-label=\"Date\" axis-type=\"category\"><chart-axis-y axis-position=\"outer-center\" axis-label=\"USD\"></chart-axis-y></chart-axis-x></chart-axis></chart-axes></chart-bar></c3chart></div></md-grid-tile></md-grid-list></md-content></div>");
$templateCache.put("app/vendor/invitations/vendor.invitation.dialog.html","<md-dialog aria-label=\"Invite User\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Invite User</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><i class=\"material-icons\">close</i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" style=\"min-width:400px;\"><md-input-container class=\"md-block\" flex=\"\"><label>Email</label> <input name=\"invitationEmail\" ng-model=\"invitation.email\" required=\"\"><div ng-messages=\"form.invitationEmail.$error\"><div ng-message=\"required\">Email is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Account Type</label><md-select name=\"invitationAccountType\" ng-model=\"invitation.accountType\" required=\"\"><md-option ng-repeat=\"accountType in accountTypes\" value=\"{{ accountType }}\">{{ accountType }}</md-option></md-select><div ng-messages=\"form.invitationAccountType.$error\"><div ng-message=\"required\">Account Type is required.</div></div></md-input-container><div style=\"color:red;\">{{ errorMessage }}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-progress-circular ng-show=\"itemLoading\" ng-disabled=\"!itemLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"md-raised md-primary\" ng-click=\"invite(form, invitation)\">Invite</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/vendor/invitations/vendor.invitations.html","<div layout=\"column\" layout-padding=\"\" infinite-scroll=\"vm.loadMoreInvitations()\" infinite-scroll-parent=\"\"><div layout=\"row\" layout-align=\"center center\"><h1 class=\"md-block\">Invitations</h1><div flex=\"\"></div><div><md-button flex=\"none\" ng-click=\"vm.inviteUser()\" class=\"md-primary md-raised\">Invite User</md-button></div></div><h3 ng-hide=\"vm.invitations.length > 0\">{{ vm.message }}</h3><md-list class=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"invitation in vm.invitations\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-align=\"left center\"><h3>{{ invitation.email }}</h3>&nbsp;<p>({{ invitation.status }})</p></div><p>{{ invitation.accountType }}</p></div><md-button class=\"\" ng-click=\"vm.resend(invitation)\">Resend</md-button><md-button class=\"md-warn\" ng-click=\"vm.cancel(invitation)\">Delete</md-button></md-list-item></md-list><div layout=\"row\" layout-align=\"center\" ng-show=\"vm.loadingMore\"><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/vendor/main/vendor.main.html","<div ng-hide=\"vm.isUser\" layout=\"row\" layout-fill=\"layout-fill\"><md-sidenav class=\"md-sidenav-left\" md-component-id=\"left\" md-is-locked-open=\"true\" md-whiteframe=\"4\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h1 class=\"md-toolbar-tools\">{{ vm.vendor.name }}</h1><div flex=\"\"></div><img style=\"height:60%;\" ng-src=\"{{ vm.vendor.imageUrl }}\"></div></md-toolbar><md-content><md-list><md-list-item ng-hide=\"vm.vendor.stripeId\"><div ui-sref=\"vendor.settings\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">settings</i></div><div class=\"inset\" style=\"color: red; font-weight: bold\">Connect Stripe</div></div></md-list-item><md-list-item ng-repeat=\"item in vm.menu\"><div ui-sref=\"{{item.sref}}\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">{{item.icon}}</i></div><div class=\"inset\">{{item.title}}</div></div></md-list-item><md-divider></md-divider><md-subheader>Settings</md-subheader><md-list-item ng-repeat=\"item in vm.settings\"><div ui-sref=\"{{item.sref}}\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">{{item.icon}}</i></div><div class=\"inset\">{{item.title}}</div></div></md-list-item><md-list-item ng-show=\"vm.account.accountType === \'Admin\'\"><div ui-sref=\"admin.dashboard\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">navigate_before</i></div><div class=\"inset\">Back to Admin Dashboard</div></div></md-list-item><md-list-item ng-show=\"vm.account.vendors.length > 1\"><div ui-sref=\"vendor.vendor-selector\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"inset\"><i class=\"material-icons\">settings</i></div><div class=\"inset\">Switch Vendor</div></div></md-list-item></md-list></md-content></md-sidenav><md-content ui-view=\"\" flex=\"\"></md-content></div><div ng-show=\"vm.isUser\" layout=\"column\" flex=\"100\" layout-align=\"center center\" layout-padding=\"10\"><div class=\"md-display-2 md-text\" style=\"text-align: center\" layout=\"row\">Login to the tablet app to access your account for {{vm.vendor.name}}</div><div ng-show=\"vm.account.vendors.length > 1\" layout=\"row\"><md-list><md-list-item ng-repeat=\"vendor in vm.vendors\"><a class=\"md-subheader\" ui-sref=\"vendor.dashboard({objectKey: vendor.key})\">Switch to {{vendor.name}}</a></md-list-item></md-list></div></div>");
$templateCache.put("app/vendor/orders/vendor.orders.html","<div layout=\"column\" layout-padding=\"\" infinite-scroll=\"vm.loadMoreOrders()\" infinite-scroll-parent=\"\"><div layout=\"row\"><h1 class=\"md-block\">Orders</h1><md-input-container style=\"margin-left:24px; margin-right: 24px; min-width: 100px;\"><label>Filter</label><md-select ng-model=\"vm.params.filter\" ng-change=\"vm.loadOrders()\" class=\"md-block\"><md-option value=\"Created\">Created</md-option><md-option value=\"Redeemed\">Redeemed</md-option><md-option value=\"ServedAndPOS\">Served</md-option></md-select></md-input-container></div><h3 ng-hide=\"vm.orders.length > 0\">{{ vm.message }}</h3><md-list class=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"order in vm.orders\"><img ng-src=\"{{ order.to.imageUrl || \'../../../assets/person.png\' }}\" class=\"md-avatar\" alt=\"Image\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ order.to.name }}</h3><p ng-repeat=\"item in order.items\">{{ item.name }}</p></div></md-list-item></md-list><div layout=\"row\" layout-align=\"center\" ng-show=\"vm.loadingMore\"><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/vendor/settings/vendor.settings.html","<div layout=\"column\" layout-padding=\"\"><h1>Account Settings</h1><h2>Stripe</h2><div>Provide the destination bank account for transactions and other information about your business using Stripe\'s secure payment platform.</div><md-button ng-show=\"true || vm.vendor.stripeId == null\" href=\"{{vm.stripeURL}}\" class=\"md-primary md-raised\">Connect a Stripe account</md-button><p ng-show=\"vm.vendor.stripeId != null\">Stripe account is connected: {{vm.vendor.stripeId}}</p><p>Last Updated: {{ vm.account.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p><form name=\"form\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Account Type</label> <input disabled=\"true\" name=\"accountType\" ng-model=\"vm.account.accountType\" flex=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Name</label> <input required=\"\" name=\"name\" ng-model=\"vm.account.name\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">Name is required.</div></div></md-input-container><md-input-container><md-button ng-disabled=\"!form.$valid\" class=\"md-primary md-raised\" ng-click=\"vm.save(form, vm.account)\">Save Changes</md-button></md-input-container></form><h1>Email Settings</h1><form name=\"emailForm\" class=\"vendor-detail\"><md-input-container class=\"md-block\"><label>Email</label> <input required=\"\" type=\"email\" name=\"email\" ng-model=\"vm.account.email\" flex=\"\"><div ng-messages=\"emailForm.email.$error\"><div ng-message=\"required\">Email is required.</div></div></md-input-container><md-input-container><md-button ng-disabled=\"!emailForm.$valid\" class=\"md-primary md-raised\" ng-click=\"vm.updateEmail(emailForm, vm.account)\">Change Email</md-button></md-input-container></form><div class=\"vendor-detail\"><h1>Other</h1><md-button class=\"md-warn md-raised\" ng-click=\"vm.logout()\">Logout</md-button><md-button class=\"\" ng-click=\"vm.grabToken()\">Grab Token (Development Only)</md-button></div><pre>{{ vm.token }}</pre><div style=\"height:100px;\"></div></div>");
$templateCache.put("app/vendor/users/vendor.users.html","<div layout=\"column\" layout-padding=\"\" infinite-scroll=\"vm.loadMoreUsers()\" infinite-scroll-parent=\"\"><div layout=\"row\"><h1 class=\"md-block\">Users</h1><md-input-container style=\"margin-left:24px; margin-right: 24px; min-width: 100px;\"><label>Filter</label><md-select ng-model=\"vm.params.type\" ng-change=\"vm.loadUsers()\" class=\"md-block\"><md-option value=\"\">All</md-option><md-option value=\"User\">Users</md-option><md-option value=\"Manager\">Managers</md-option><md-option value=\"Suspended\">Suspended</md-option></md-select></md-input-container><md-input-container style=\"margin-left:24px; margin-right: 24px;\" flex=\"\" class=\"md-block\"><label>Search</label> <input name=\"search\" ng-model=\"vm.params.search\" ng-change=\"vm.loadUsers()\"></md-input-container></div><md-list class=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"user in vm.users\"><img ng-src=\"{{ user.imageUrl || \'../../../assets/person.png\' }}\" class=\"md-avatar\" alt=\"Image\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ user.name }}</h3><p>{{ user.accountType }}</p></div><md-button ng-show=\"user.accountType === \'User\'\" class=\"md-warn\" ng-click=\"vm.block(user)\">Suspend</md-button><md-button ng-show=\"user.accountType === \'Suspended\'\" class=\'md-primary\"\' ng-click=\"vm.unblock(user)\">Reactivate</md-button><md-button ng-show=\"user.accountType === \'User\' || user.accountType == \'Suspended\'\" class=\"md-warn\" ng-click=\"vm.remove(user)\">Remove</md-button></md-list-item></md-list><div layout=\"row\" layout-align=\"center\" ng-show=\"vm.loadingMore\"><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/vendor/vendor-selector/vendor.vendor-selector.html","<div layout=\"column\" layout-padding=\"\"><div layout=\"row\"><h1 class=\"md-block\">Vendors</h1></div><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"vendor in vm.vendors\"><img ng-src=\"{{vendor.imageUrl}}\" class=\"md-avatar\" alt=\"{{vendor.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ vendor.name }}</h3><p class=\"error\">{{ vendor.active ? \'\' : \'Inactive\' }}</p><p>{{ vendor.location.street }} {{ vendor.location.city }} {{ vendor.location.state }} {{ vendor.location.postalCode }}</p></div><md-button ui-sref=\"vendor.dashboard({objectKey:vendor.key})\">Manage</md-button></md-list-item></md-list></div>");
$templateCache.put("app/common/vendor/detail/vendor.detail.html","<div layout=\"column\" layout-padding=\"\"><div layout=\"row\" layout-align=\"center center\"><h1>{{ vm.vendor.name || \'New Vendor\'}}</h1><md-switch aria-label=\"Active\" ng-disabled=\"!vm.vendor.stripeId\" ng-model=\"vm.vendor.active\" class=\"md-primary\" style=\"margin-left:24px; margin-right:24px;\">{{ vm.vendor.active ? \'Active\' : \'Inactive\'}} <a ui-sref=\"vendor.settings\" ng-hide=\"vm.vendor.stripeId\">(Connect a Stripe account to enable activation)</a></md-switch><div flex=\"\"></div><md-progress-circular ng-show=\"vm.loading\" ng-disabled=\"!vm.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button ng-hide=\"vm.vendor.key\" flex=\"none\" ng-click=\"vm.save(form)\" class=\"md-primary md-raised\">Create</md-button><md-button ng-show=\"vm.vendor.key\" flex=\"none\" ng-click=\"vm.save(form)\" class=\"md-primary md-raised\">Save Changes</md-button></div><form name=\"form\" class=\"vendor-detail\"><div layout=\"row\"><md-input-container class=\"md-block\" ng-show=\"vm.vendor.stripeId\" flex=\"\"><label>Stripe ID</label> <input ng-disabled=\"true\" name=\"stripeId\" ng-model=\"vm.vendor.stripeId\" flex=\"\"></md-input-container><md-input-container class=\"md-block\" ng-show=\"vm.vendor.stripeId\" style=\"margin-top:0;\"><md-button target=\"_blank\" class=\"md-raised\" ng-click=\"vm.goToStripeDashboard()\">GO TO Stripe Dashboard &nbsp;<i class=\"material-icons\" style=\"top:6px; position:relative;\">launch</i></md-button></md-input-container></div><md-input-container class=\"md-block\"><label>Name</label> <input required=\"\" name=\"name\" ng-model=\"vm.vendor.name\" flex=\"\"><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-input-container flex=\"50\"><label>Phone</label> <input required=\"\" name=\"phone\" ng-model=\"vm.vendor.phone\"><div ng-messages=\"form.phone.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container flex=\"50\"><label>Website</label> <input required=\"\" name=\"website\" ng-model=\"vm.vendor.website\"><div ng-messages=\"form.website.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Description</label> <textarea name=\"description\" ng-model=\"vm.vendor.description\" md-maxlength=\"150\" md-select-on-focus=\"\"></textarea><div ng-messages=\"form.description.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Address</label> <input ng-model=\"vm.vendor.location.street\"></md-input-container><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>City</label> <input ng-model=\"vm.vendor.location.city\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>State</label><md-select ng-model=\"vm.vendor.location.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Postal Code</label> <input name=\"postalCode\" ng-model=\"vm.vendor.location.postalCode\" required=\"\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"form.postalCode.$error\"><div ng-message=\"required\" class=\"my-message\">You must supply a postal code.</div><div ng-message=\"pattern\" class=\"my-message\">That doesn\'t look like a valid postal code.</div><div ng-message=\"maxlength\" class=\"my-message\">Please use the short version of the postal code (5 digits)</div></div></md-input-container></div><md-button style=\"height:35px; margin-left:0;\" class=\"md-primary md-raised\" ng-click=\"vm.geocode()\">Geocode</md-button><p class=\"detail\">The address that you provide must be a valid address. If geocoding the entire address does not yield valid latitude and longitude values below then users will not be recommended your spot based on their location.</p><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Latitude</label> <input disabled=\"true\" ng-model=\"vm.vendor.location.latitude\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Longitude</label> <input disabled=\"true\" ng-model=\"vm.vendor.location.longitude\"></md-input-container></div><div><h3>Logo Image</h3><file-uploader path=\"vendor-image\" on-upload=\"vm.onProfileImageUpload(fileUrl)\"></file-uploader><input type=\"hidden\" name=\"imageUrl\" ng-model=\"vm.vendor.imageUrl\"><md-card style=\"width: 250px\"><img class=\"md-card-image\" ng-src=\"{{ vm.vendor.imageUrl }}\"></md-card></div><div><h3>Gallery Images</h3><file-uploader path=\"vendor-image\" on-upload=\"vm.onImageUpload(fileUrl)\"></file-uploader><div ng-repeat=\"$imageUrl in vm.vendor.imageUrls\"><md-card style=\"width: 250px; float: left\"><img class=\"md-card-image\" ng-src=\"{{ $imageUrl }}\"><md-card-actions layout=\"column\"><md-button aria-label=\"Remove\" ng-click=\"vm.removeImageUrl($index)\">Remove</md-button></md-card-actions></md-card></div></div></form><div ng-show=\"vm.vendor.documentUrl\"><md-card><md-card-title>Documents</md-card-title><md-card-content><md-button class=\"md-raised\" href=\"{{vm.vendor.documentUrl}}\" target=\"_blank\">View Document</md-button></md-card-content></md-card></div><div class=\"md-warn\">{{ vm.error }}</div></div>");
$templateCache.put("app/common/vendor/menu/vendor.category.dialog.html","<md-dialog aria-label=\"New Menu Category\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>New Menu Category</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><i class=\"material-icons\">close</i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\" flex=\"\"><label>Category Name</label> <input name=\"categoryName\" ng-model=\"category.name\"><div ng-messages=\"form.categoryName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><h3>Image</h3><file-uploader path=\"vendor-category-image\" on-upload=\"onCategoryImageUpload(fileUrl)\"></file-uploader><input type=\"hidden\" name=\"imageUrl\" ng-model=\"category.imageUrl\"><div ng-messages=\"form.imageUrl.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div><img ng-show=\"category.imageUrl\" style=\"width:150px; height:150px;\" ng-src=\"{{category.imageUrl}}\"></div><div style=\"color:red;\">{{ errorMessage }}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-progress-circular ng-show=\"categoryLoading\" ng-disabled=\"!categoryLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button class=\"md-raised md-primary\" ng-click=\"insert(form, category)\">Create</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/common/vendor/menu/vendor.item.dialog.html","<md-dialog aria-label=\"Edit Menu Item\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ item.name || \'New Menu Item\' }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><i class=\"material-icons\">close</i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" style=\"min-width:700px;\"><md-input-container class=\"md-block\" flex=\"100\"><label>Select a product template (Optional)</label><md-autocomplete md-selected-item=\"selectedItem\" md-selected-item-change=\"useTemplate(selectedItem)\" md-search-text=\"searchText\" md-items=\"itemTemplate in searchItemTemplates(searchText)\" md-item-text=\"itemTemplate.name\" md-require-match=\"true\"><md-item-template><span md-highlight-text=\"searchText\">{{itemTemplate.name}}</span></md-item-template></md-autocomplete></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Item Name</label> <input name=\"itemName\" ng-disabled=\"selectedItem\" ng-model=\"item.name\"><div ng-messages=\"form.itemName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div style=\"width:24px;\"></div><md-input-container class=\"md-block\" flex=\"\"><h3>Image</h3><file-uploader path=\"vendor-item-image\" on-upload=\"onItemImageUpload(fileUrl)\"></file-uploader><input type=\"hidden\" name=\"imageUrl\" ng-disabled=\"selectedItem\" ng-model=\"item.imageUrl\"> <img ng-show=\"item.imageUrl\" style=\"width:150px; height:150px;\" ng-src=\"{{item.imageUrl}}\"><div ng-messages=\"form.imageUrl.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><md-input-container class=\"md-block\" flex=\"\"><label>Description</label> <input name=\"itemDescription\" ng-disabled=\"selectedItem\" ng-model=\"item.description\"><div ng-messages=\"form.itemDescription.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Category</label><md-select ng-model=\"item.category.key\"><md-option ng-repeat=\"category in categories track by category.key\" value=\"{{ category.key }}\">{{ category.name }}</md-option></md-select></md-input-container><div style=\"width:24px;\"></div><md-input-container class=\"md-block\" flex=\"\"><label>Subcategory</label> <input name=\"subcategory\" ng-model=\"item.subcategory\"><div ng-messages=\"form.subcategory.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Price in Cents (USD)</label> <input name=\"price\" ng-model=\"item.price\"></md-input-container><div style=\"width:24px;\"></div><md-input-container><label>Display Price</label> <input name=\"currency\" ng-disabled=\"true\" value=\"{{ (item.price / 100) | currency }} USD\"></md-input-container></div><div style=\"color:red;\">{{ errorMessage }}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-progress-circular ng-show=\"itemLoading\" ng-disabled=\"!itemLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button class=\"md-raised md-primary\" ng-click=\"save(form, item)\">{{ item.key ? \'Update\' : \'Add\' }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/common/vendor/menu/vendor.menu.html","<div layout=\"column\" layout-padding=\"\"><div layout=\"row\" layout-align=\"center center\"><h1>{{ vm.vendor.name }} Menu</h1><div flex=\"\"></div><md-button flex=\"none\" class=\"md-primary md-raised\" ng-click=\"vm.addCategory()\">Add Category</md-button></div><div ui-sortable=\"vm.categoryTabSortOptions\" ng-model=\"vm.categoryList\" class=\"category-tab-container\"><md-tabs md-selected=\"selectedIndex\" md-border-bottom=\"\" md-autoselect=\"\"><md-tab ng-repeat=\"category in vm.categoryList\" ng-click=\"vm.selectedCategory = category\" label=\"{{ category.name }}\"></md-tab></md-tabs></div><div ng-show=\"vm.selectedCategory\"><div layout=\"column\" class=\"vendor-detail\"><form name=\"categoryForm\"><div layout=\"row\"><h2 ng-show=\"vm.selectedCategory.archived\">Category is archived</h2><md-switch ng-model=\"vm.selectedCategory.active\" ng-show=\"!vm.selectedCategory.archived\" ng-change=\"vm.updateCategory(categoryForm, vm.selectedCategory)\"><div ng-show=\"vm.selectedCategory.active\">Category is visible in the menu</div><div ng-show=\"!vm.selectedCategory.active\">Category is not available in the menu</div></md-switch><span flex=\"\"></span><md-button style=\"color: red\" ng-show=\"!vm.selectedCategory.archived\" ng-click=\"vm.archiveCategory(vm.selectedCategory)\">Archive</md-button></div><div layout=\"row\" style=\"margin-top:20px;\"><div style=\"margin-right: 20px;\"><img style=\"width:50px; height:50px;\" ng-src=\"{{vm.selectedCategory.imageUrl}}\"><file-uploader ng-hide=\"vm.selectedCategory.archived\" path=\"vendor-category-image\" on-upload=\"onCategoryImageUpload(fileUrl)\"></file-uploader><input type=\"hidden\" name=\"imageUrl\" ng-model=\"vm.selectedCategory.imageUrl\"></div><md-input-container class=\"md-block\" flex=\"\"><label>Category Name</label> <input name=\"categoryName\" ng-disabled=\"vm.selectedCategory.archived\" ng-model=\"vm.selectedCategory.name\"><div ng-messages=\"categoryForm.categoryName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div></form><div layout=\"row\" flex=\"\" style=\"margin-top: -35px;\" layout-align=\"center center\"><md-button ng-click=\"vm.deleteCategory()\" class=\"md-warn\">Delete Category</md-button><div flex=\"\"></div><md-progress-circular ng-show=\"vm.categoryLoading\" ng-disabled=\"!vm.categoryLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-button ng-show=\"!vm.selectedCategory.archived\" ng-click=\"vm.updateCategory(categoryForm, vm.selectedCategory)\" class=\"md-primary md-raised\">Save Category</md-button></div></div><div layout=\"row\" layout-align=\"center center\"><h3>Menu Items ({{ vm.selectedCategory.name }})</h3><div flex=\"\"></div><md-button ng-show=\"!vm.selectedCategory.archived\" flex=\"none\" class=\"md-primary md-raised\" ng-click=\"vm.editItem(vm.selectedCategory)\">Add Item</md-button></div><div ui-sortable=\"vm.itemSortOptions\" ng-model=\"vm.selectedCategory.activeItems\" class=\"itemContainer\"><md-list class=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"item in vm.selectedCategory.activeItems\" layout-align=\"center\"><img ng-src=\"{{ item.imageUrl }}\" class=\"md-avatar\" alt=\"{{item.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.name }}</h3><p>{{ item.description }}</p></div><div layout=\"row\" layout-align=\"center center\" flex=\"\"><div flex=\"\" style=\"text-align:right; padding-left:50px; padding-right:20px;\">{{ item.price / 100 | currency }}</div><md-button ng-disabled=\"item.archived\" ng-click=\"vm.editItem(vm.selectedCategory, item)\">Edit</md-button><md-switch ng-model=\"item.active\" ng-change=\"vm.toggleItemActive(vm.selectedCategory, item)\"><div ng-show=\"item.active\">Visible</div><div ng-show=\"!item.active\">Hidden</div></md-switch><md-button style=\"color: red\" ng-show=\"!item.archived\" ng-click=\"vm.archiveItem(vm.selectedCategory, item)\">Archive</md-button></div></md-list-item></md-list></div><h3>Archived Items</h3><md-list class=\"\" style=\"opacity: 0.3\"><md-list-item class=\"md-2-line\" ng-repeat=\"item in vm.selectedCategory.archivedItems\" layout-align=\"center\"><img ng-src=\"{{ item.imageUrl }}\" class=\"md-avatar\" alt=\"{{item.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.name }}</h3><p>{{ item.description }}</p></div></md-list-item></md-list></div></div>");}]);